"use client"

import { useState, useRef, useEffect, useMemo } from "react"
import { PDFDocument } from "pdf-lib"
import { saveAs } from "file-saver"
import CKEditor from "ckeditor4-react"
import * as pdfjs from "pdfjs-dist/build/pdf"
import { GlobalWorkerOptions } from "pdfjs-dist/build/pdf"
import html2pdf from "html2pdf.js"
import * as XLSX from "xlsx"
import Alert from "../../common/Alerts/Alerts"
import { useDispatch, useSelector } from "react-redux"
import { callCommonAction } from "../../redux/Common/CommonReducer"
import { sendRequest } from "../../apis/APIs"
import { validateProposalFormData } from "./ValidationProposalForm"
import { useLocation } from "react-router-dom"
import appRoutes from "../../configs/AppRoutes"
import { useNavigate } from "react-router-dom"
import { handleApiResponse } from "../../apis/apiUtils"
import mammoth from "mammoth"
import SendPdfToEmail from "./SendPdfToEmail"
import UserAddDocument from "./UserAddDocument"
import Chat from "./Chat"
import { useParams } from "react-router-dom"
import { Modal, Form, Spinner } from "react-bootstrap"

const PdfEditor = () => {
  const [pdfBytes, setPdfBytes] = useState(null)
  const { id } = useParams() // Get the 'id' from the URL parameter
  const [ckeContentError, setCkeContentError] = useState("")
  const [proposalsContents, setProposalsContents] = useState({})
  const [rawInput, setRawInput] = useState("")
  const [proposalImages, setProposalImages] = useState({})
  const [currentPageIndex, setCurrentPageIndex] = useState(null)
  const [documentList, setDocumentList] = useState([])
  const [selectedDocument, setSelectedDocument] = useState(null)
  const [documentPagesMap, setDocumentPagesMap] = useState({})
  const [tags, setTags] = useState([]) // Store the tags entered by the user
  const [documentproposalImagesMap, setDocumentproposalImagesMap] = useState({})
  const [isProcessing, setIsProcessing] = useState(false)
  const [editorContent, setEditorContent] = useState("")
  const [selectedProposals, setSelectedProposals] = useState({})
  const [selectedPagesToRemove, setSelectedPagesToRemove] = useState({})
  const [isIframeLoading, setIsIframeLoading] = useState(false)
  const newPageContentRef = useRef("")
  const editorRef = useRef(null)
  const [errorsInfo, setErrorsInfo] = useState({})
  const [filter, setFilter] = useState({ search: "" })
  const { state } = useLocation()
  const initialProposal = state?.proposal || {} // Initialize with proposal from location state
  const [proposal, setProposal] = useState(initialProposal) // State to hold the proposal
  const location = useLocation()
  const { data, firstedit } = location.state || {}
  const [proposalIsEditable, setProposalIsEditable] = useState([])
  const [previewImage, setPreviewImage] = useState(null)
  const [showPreviewPopup, setShowPreviewPopup] = useState(false)
  const [showDownloadPopup, setShowDownloadPopup] = useState(false)
  const [documentProposalData, setDocumentProposalData] = useState({ title: "", metatitle: "", is_draft: false })
  const [previewSelectedImages, setPreviewSelectedImages] = useState({})
  const [currentPreviewDocBytes, setCurrentPreviewDocBytes] = useState(null)
  const [currentPreviewPageIdx, setCurrentPreviewPageIdx] = useState(null)
  const [currentPreviewDocIndex, setCurrentPreviewDocIndex] = useState(null)
  const [previewableImages, setPreviewableImages] = useState([])
  const [currentPreviewImageIndex, setCurrentPreviewImageIndex] = useState(0)
  const [shouldHidePreview, setShouldHidePreview] = useState(false)
  const [highResPreviewCache, setHighResPreviewCache] = useState({})
  const [selectedDocumentId, setSelectedDocumentId] = useState(null)
  const [saveId, setSaveId] = useState("")
  const [pagesIndex, setPgesIndex] = useState("")
  const [leftPanelVisible, setLeftPanelVisible] = useState(true)
  const [showModal, setShowModal] = useState(false)
  const [showUserAddDocument, setShowUserDocumentPopup] = useState(false)
  const [hasImageData, setHasImageData] = useState(false)
  const [thumbnailCache, setThumbnailCache] = useState({})
  const [categories, setCategories] = useState([])
  const [pageSelection, setPageSelection] = useState([])

  const [rightPanelVisible, setRightPanelVisible] = useState(true)
  // Add state for loading indicators for each tab
  const [tabLoading, setTabLoading] = useState({ oldDocuments: false, masterDocuments: false, drafts: false })
  const [key, setKey] = useState("1")
  const [isTabChanging, setIsTabChanging] = useState(false)
  const [viewMode, setViewMode] = useState("list") // "list" or "thumbnails"
  const [thumbnailsLoading, setThumbnailsLoading] = useState(false)
  const [activeDocumentName, setActiveDocumentName] = useState("")
  const [activeSection, setActiveSection] = useState("1")
  const [rejectedData, setRejectedData] = useState([])
  const [selectAll, setSelectAll] = useState(false)
  const masterDocIds = [138, 144, 145, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 283]

  const [editorPanelVisible, setEditorPanelVisible] = useState(true)

  const toggleEditor = () => {
    setEditorPanelVisible((prev) => !prev)
  }

  const selectRef = useRef(null)
  const dispatch = useDispatch()
  const { user, alert, loading, loading1, loading2, loading3, loading5, loading7, loading9 } = useSelector(
    (state) => state.common,
  )
  const [updatedPageContents, setUpdatedPageContents] = useState([])
  const [users, setUsers] = useState([])

  const navigate = useNavigate()
  useEffect(() => {
    getRawData()
  }, [])

  // Initialize PDF.js worker
  useEffect(() => {
    if (!GlobalWorkerOptions.workerSrc) {
      GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`
    }
  }, [])

  // Create initial empty PDF
  useEffect(() => {
    createNewPdf()
  }, [])

  // Load proposal data when component mounts
  useEffect(() => {
    if (proposal) {
      console.log(proposal,"xxxxxxxxxxxxxxxxxxxxxxxxxxx")
      loadProposalFromData(proposal)
    }
  }, [proposal])

  useEffect(() => {
    if (id && proposal?.document_contents?.length) {
      const defaultContent = proposal.document_contents[0]
      const htmlContent = `
        <h2>${defaultContent.projectName || ""}</h2>
        <p>${defaultContent.description || ""}</h2>
        <p>${defaultContent.title || ""}</h2>
      `

      newPageContentRef.current = htmlContent
      setCurrentPageIndex(0)

      setProposalIsEditable((prev) => {
        const updated = [...prev]
        updated[0] = { isEditable: true, type: "true" }
        return updated
      })

      setEditorContent(htmlContent)

      // Delay to ensure all state updates before update
      setTimeout(() => {
        updateSelectedProposalContentWithHTML()
      }, 100) // You can tweak the delay if needed
    }
  }, [proposal])

  // useEffect(() => {
  //   if (data && pdfBytes) {
  //     console.log(data, "Data and PDF loaded");

  //     const htmlContent = `
  //       <h2>${data.projectName || ""}</h2>
  //       <p>${data.description || ""}</h2>
  //       <p>${data.title || ""}</h2>
  //     `;

  //     newPageContentRef.current = htmlContent;
  //     setCurrentPageIndex(0);
  //     setEditorContent(htmlContent);

  //     setTimeout(() => {
  //       console.log("Calling updateSelectedProposalContentWithHTML");
  //       updateSelectedProposalContentWithHTML();
  //     }, 1000);
  //   } else {
  //     console.log("Waiting for data or PDF bytes...");
  //   }
  // }, [data, pdfBytes]); // ⬅️ triggers only when both are available

  useEffect(() => {
    if (proposal) {
      // Extract tags from the metatitle string
      const existingTags = proposal.metatitle
        ? proposal.metatitle
            .split(",")
            .map((tag) => tag.trim())
            .filter((tag) => tag)
        : []

      // Update documentProposalData and tags
      setDocumentProposalData((prevData) => ({
        ...prevData,
        title: proposal.title || "", // Update the title
        metatitle: existingTags.join(","), // Set metatitle as comma-separated tags
      }))

      setTags(existingTags) // Set tags with the extracted tags from metatitle
      setSaveId(proposal.id) // Save the proposal ID
    }
  }, [proposal])

  // Generate PDF blob URL for viewer
  useEffect(() => {
    if (pdfBytes) generateThumbnails(pdfBytes)
  }, [pdfBytes])

  useEffect(() => {
    getCategories()
  }, [])

  useEffect(() => {
    if (selectedDocument && id) {
      getPageSelections()
    }
  }, [selectedDocument])

  // Generate thumbnails for document library
  useEffect(() => {
    if (documentList.length > 0) generateAllDocumentThumbnails()
  }, [documentList])

  useEffect(() => {
    if (currentPageIndex !== null && proposal?.document_contents) {
      const contentForPage = proposal.document_contents.find((doc) => doc.page_index === currentPageIndex)

      let content = ""

      if (contentForPage?.content) {
        content = contentForPage.content
      } else if (currentPageIndex === 0 && data) {
        content = `
          <h2>Name: ${data.projectName}</h2>
          <p><strong>Description:</strong> ${data.description}</h2>
        `
      }
      setEditorContent(content)
      newPageContentRef.current = content
      if (editorRef.current) {
        console.log("Updating editor instance with content")
        editorRef.current.setData(content)
      }

      // Check if the content has image data
      setHasImageData(checkForImageData(content))
    }
  }, [currentPageIndex, proposal?.document_contents, data])

  useEffect(() => {
    const interval = setInterval(() => {
      console.log(showDownloadPopup, "showDownloadPopup")
      if (!showDownloadPopup) {
        setDocumentProposalData((prev) => ({ ...prev, is_draft: true }))
        handleAutoSave()
      }
    }, 10000) // 10 seconds, not 4 minutes

    return () => clearInterval(interval)
  }, [pdfBytes, updatedPageContents, documentProposalData, showDownloadPopup])

  // Reset selected pages when document changes
  useEffect(() => {
    setSelectedProposals({})
  }, [selectedDocument])

  // Reset selected pages to remove when PDF changes
  useEffect(() => {
    setSelectedPagesToRemove({})
  }, [pdfBytes])

  const pdfBlobUrl = useMemo(() => {
    if (!pdfBytes) return null
    const blob = new Blob([pdfBytes], { type: "application/pdf" })
    const url = URL.createObjectURL(blob)
    // Add page parameter to show the selected page
    return currentPageIndex !== null ? `${url}#page=${Number(currentPageIndex) + 1}` : url
  }, [pdfBytes, currentPageIndex])

  // Cleanup blob URL on unmount
  useEffect(() => {
    return () => {
      if (pdfBlobUrl) URL.revokeObjectURL(pdfBlobUrl)
    }
  }, [pdfBlobUrl])

  // useEffect(() => {
  //   if (rightPanelVisible && key) {
  //     getRawData(key)
  //   }
  // }, [rightPanelVisible, key])

  // Toggle panel functions
  const toggleLeftPanel = () => {
    setLeftPanelVisible(!leftPanelVisible)
  }

  const toggleRightPanel = () => {
    setRightPanelVisible(!rightPanelVisible)
  }

  // Modify the generateNonPdfThumbnail function to create more realistic thumbnails
  const generateNonPdfThumbnail = (fileType, pageNumber = 1, title = "") => {
    // Create a canvas element
    const canvas = document.createElement("canvas")
    const ctx = canvas.getContext("2d")
    if (!ctx) return null

    canvas.width = 140
    canvas.height = 200

    // Draw background
    ctx.fillStyle = "#ffffff"
    ctx.fillRect(0, 0, canvas.width, canvas.height)

    // Draw file type icon background
    ctx.fillStyle =
      fileType === "excel" || fileType === "xlsx" || fileType === "xls"
        ? "#217346" // Excel green
        : "#2b579a" // Word blue
    ctx.fillRect(20, 20, 100, 100)

    // Draw file extension text
    ctx.fillStyle = "white"
    ctx.font = "bold 24px Arial"
    ctx.textAlign = "center"
    ctx.fillText(fileType === "excel" || fileType === "xlsx" || fileType === "xls" ? "XLS" : "DOC", 70, 80)

    // Draw page/sheet number
    ctx.fillStyle = "#333333"
    ctx.font = "14px Arial"
    ctx.textAlign = "center"
    ctx.fillText(
      fileType === "excel" || fileType === "xlsx" || fileType === "xls" ? `Sheet ${pageNumber}` : `Page ${pageNumber}`,
      70,
      140,
    )

    // Draw title if provided
    if (title) {
      ctx.fillStyle = "#333333"
      ctx.font = "12px Arial"
      ctx.textAlign = "center"

      // Truncate title if too long
      let displayTitle = title
      if (title.length > 15) {
        displayTitle = title.substring(0, 12) + "..."
      }

      ctx.fillText(displayTitle, 70, 160)
    }

    return canvas.toDataURL()
  }

  useEffect(() => {
    getDocumentByData() // Fetch data when proposal.id is available
  }, [id]) // Trigger effect when proposal.id changes

  const getDocumentByData = async () => {
    try {
      if (!id) return // Ensure ID is available before making the request
      const res = await sendRequest(`/user/documents-get/${id}`, "GET")

      if (res.data.type === "success") {
        // setDocumentList([res.data.data]) // Set document list as an array
        setProposal(res.data.data) // Set proposal if needed
        setUsers(res?.data?.users) // Set proposal if needed
      }
    } catch (error) {
      console.log("Error fetching document data:", error) // Handle API error
    }
  }

  // useEffect(() => {
  //   if (selectedDocument?.id == 283) {
  //     getMasterDocContent()
  //   }
  // }, [selectedDocument])

  // const getMasterDocContent = async () => {
  //   try {
  //     console.log(selectedDocument, "selectedDocument")
  //     const res = await sendRequest(`/user/get-master-doc/${selectedDocument?.id}`, "GET")

  //     if (res.data.type === "success") {
  //       setEditorContent(res.data.data)
  //     }
  //   } catch (error) {
  //     console.log("Error fetching document data:", error) // Handle API error
  //   }
  // }

  const processExcelDocument = async (arrayBuffer) => {
    try {
      // Load the workbook
      const workbook = XLSX.read(arrayBuffer, { type: "array" })

      // Create thumbnails and HTML content for each sheet
      const thumbnails = {}
      const contents = {}
      let thumbnailIndex = 0

      workbook.SheetNames.forEach((sheetName, sheetIndex) => {
        // Get the worksheet
        const worksheet = workbook.Sheets[sheetName]

        // Convert sheet to JSON to easily work with the data
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 })

        // Skip empty sheets
        if (!jsonData || jsonData.length === 0) {
          return
        }

        // Get header row if it exists
        const headerRow = jsonData[0]

        // Calculate how many chunks we need (5 rows per chunk)
        const rowsPerChunk = 14
        const dataRows = jsonData.slice(1) // Remove header row
        const totalChunks = Math.ceil(dataRows.length / rowsPerChunk)

        // Create thumbnails and content for each chunk
        for (let chunkIndex = 0; chunkIndex < totalChunks; chunkIndex++) {
          // Get the rows for this chunk
          const startRow = chunkIndex * rowsPerChunk
          const endRow = Math.min(startRow + rowsPerChunk, dataRows.length)
          const chunkRows = dataRows.slice(startRow, endRow)

          // Generate thumbnail for this chunk
          thumbnails[thumbnailIndex] = generateExcelThumbnail(
            "excel",
            chunkIndex + 1,
            `${sheetName} (${startRow + 1}-${endRow})`,
          )

          // Create HTML content for this chunk
          const chunkHtml = createExcelChunkHtml(headerRow, chunkRows, sheetName, chunkIndex + 1)
          contents[thumbnailIndex] = chunkHtml

          thumbnailIndex++
        }
      })

      return {
        thumbnails,
        contents,
        pageCount: thumbnailIndex,
      }
    } catch (error) {
      console.error("Error processing Excel document:", error)
      return {
        thumbnails: { 0: generateNonPdfThumbnail("excel") },
        contents: { 0: "<p>Error processing Excel document</p>" },
        pageCount: 1,
      }
    }
  }

  // New function to process Word documents
  const processWordDocument = async (arrayBuffer) => {
    try {
      // Convert Word document to HTML using mammoth
      const result = await mammoth.convertToHtml({ arrayBuffer })
      const htmlContent = result.value

      // Split the content into chunks (paragraphs)
      const paragraphs = htmlContent.split(/<\/?p>/).filter((p) => p.trim().length > 0)

      // Calculate how many chunks we need (10 paragraphs per chunk)
      const paragraphsPerChunk = 10
      const totalChunks = Math.ceil(paragraphs.length / paragraphsPerChunk)

      // Create thumbnails and HTML content for each chunk
      const thumbnails = {}
      const contents = {}

      for (let chunkIndex = 0; chunkIndex < totalChunks; chunkIndex++) {
        // Get the paragraphs for this chunk
        const startPara = chunkIndex * paragraphsPerChunk
        const endPara = Math.min(startPara + paragraphsPerChunk, paragraphs.length)
        const chunkParagraphs = paragraphs.slice(startPara, endPara)

        // Generate thumbnail for this chunk
        thumbnails[chunkIndex] = generateWordThumbnail(
          "word",
          chunkIndex + 1,
          `Chunk ${chunkIndex + 1} (${startPara + 1}-${endPara})`,
        )

        // Create HTML content for this chunk
        const chunkHtml = createWordChunkHtml(chunkParagraphs, chunkIndex + 1)
        contents[chunkIndex] = chunkHtml
      }

      return {
        thumbnails,
        contents,
        pageCount: totalChunks,
      }
    } catch (error) {
      console.error("Error processing Word document:", error)
      return {
        thumbnails: { 0: generateNonPdfThumbnail("word") },
        contents: { 0: "<p>Error processing Word document</p>" },
        pageCount: 1,
      }
    }
  }

  const generateWordThumbnail = (fileType, chunkNumber, title) => {
    const canvas = document.createElement("canvas")
    const ctx = canvas.getContext("2d")
    if (!ctx) return null

    canvas.width = 140
    canvas.height = 200

    // Background
    ctx.fillStyle = "#ffffff"
    ctx.fillRect(0, 0, canvas.width, canvas.height)

    // File icon background (Word blue)
    ctx.fillStyle = "#2B579A"
    ctx.fillRect(20, 20, 100, 100)

    // File extension text
    ctx.fillStyle = "white"
    ctx.font = "bold 24px Arial"
    ctx.textAlign = "center"
    ctx.fillText("DOC", 70, 80)

    // Chunk number
    ctx.fillStyle = "#333333"
    ctx.font = "14px Arial"
    ctx.textAlign = "center"
    ctx.fillText(`Chunk ${chunkNumber}`, 70, 140)

    // Title
    if (title) {
      ctx.fillStyle = "#333333"
      ctx.font = "12px Arial"
      ctx.textAlign = "center"
      const displayTitle = title.length > 15 ? title.substring(0, 12) + "..." : title
      ctx.fillText(displayTitle, 70, 160)

      // Optional: Add lines or "summary" for Word files
      ctx.fillStyle = "#2B579A"
      ctx.font = "10px Arial"
      ctx.fillText("Word content", 70, 180)
    }

    return canvas.toDataURL()
  }

  const createWordChunkHtml = (paragraphs, chunkNumber, title = "") => {
    const contentHtml = paragraphs
      .map((p) => {
        return `<p style="margin: 8px 0; line-height: 1.4;">${p}</p>`
      })
      .join("")

    const styledHtml = `
      <div style="font-family: Georgia, serif; color: #333;">
        <div style="padding: 10px; border: 1px solid #ccc; border-radius: 6px;">
          ${contentHtml}
        </div>
      </div>
    `

    return styledHtml
  }

  // Function to generate Excel thumbnails with more detailed preview
  const generateExcelThumbnail = (fileType, chunkNumber, title) => {
    // Create a canvas element
    const canvas = document.createElement("canvas")
    const ctx = canvas.getContext("2d")
    if (!ctx) return null

    canvas.width = 140
    canvas.height = 200

    // Draw background
    ctx.fillStyle = "#ffffff"
    ctx.fillRect(0, 0, canvas.width, canvas.height)

    // Draw file type icon background
    ctx.fillStyle = "#217346" // Excel green
    ctx.fillRect(20, 20, 100, 100)

    // Draw file extension text
    ctx.fillStyle = "white"
    ctx.font = "bold 24px Arial"
    ctx.textAlign = "center"
    ctx.fillText("XLS", 70, 80)

    // Draw chunk number
    ctx.fillStyle = "#333333"
    ctx.font = "14px Arial"
    ctx.textAlign = "center"
    ctx.fillText(`Chunk ${chunkNumber}`, 70, 140)

    // Draw title if provided
    if (title) {
      ctx.fillStyle = "#333333"
      ctx.font = "12px Arial"
      ctx.textAlign = "center"

      // Truncate title if too long
      let displayTitle = title
      if (title.length > 15) {
        displayTitle = title.substring(0, 12) + "..."
      }

      ctx.fillText(displayTitle, 70, 160)

      // Draw "5 rows" text
      ctx.fillStyle = "#217346"
      ctx.font = "10px Arial"
      ctx.textAlign = "center"
      ctx.fillText("5 rows per chunk", 70, 180)
    }

    return canvas.toDataURL()
  }

  // Function to create HTML content for a chunk of Excel data
  const createExcelChunkHtml = (headerRow, dataRows, sheetName, chunkNumber) => {
    // Create table HTML
    let tableHtml = '<table style="border-collapse: collapse; width: 100%;">'

    // Add header row
    if (headerRow && headerRow.length > 0) {
      tableHtml += "<thead><tr>"
      headerRow.forEach((cell) => {
        tableHtml += `<th style="border: 1px solid #ddd; padding: 8px; background-color: #f2f2f2;">${cell || ""}</th>`
      })
      tableHtml += "</tr></thead>"
    }

    // Add data rows
    tableHtml += "<tbody>"
    dataRows.forEach((row) => {
      tableHtml += "<tr>"
      if (Array.isArray(row)) {
        row.forEach((cell) => {
          tableHtml += `<td style="border: 1px solid #ddd; padding: 8px;">${cell !== undefined ? cell : ""}</td>`
        })
      } else {
        // Handle case where row might be an object (with header: 1 option)
        headerRow.forEach((header) => {
          tableHtml += `<td style="border: 1px solid #ddd; padding: 8px;">${row[header] !== undefined ? row[header] : ""}</td>`
        })
      }
      tableHtml += "</tr>"
    })
    tableHtml += "</tbody></table>"

    // Wrap in a styled div
    const styledHtml = `
    <div style="font-family: Arial, sans-serif;">
      <div style="overflow-x: auto;">
        ${tableHtml}
      </div>
    </div>
  `

    return styledHtml
  }
  const getRawData = async (tabKey, search = "") => {
    try {
      setTabLoading((prev) => ({
        ...prev,
        [tabKey]: true,
      }))

      const actualTabKey = tabKey ? tabKey : "1"

      const res = await sendRequest(`/user/documents/${actualTabKey}`, "GET", { search })

      if (res.data.documents) {
        let sourceDocs = []
           sourceDocs = res.data.documents
        setRejectedData(res.data.documents)
        const newDocuments = sourceDocs.map((doc) => {
          console.log(doc,"docdocdocdoc")
          let fileBytes = null

          if (doc.file_bytes) {
            const base64ToArrayBuffer = (base64) => {
              const binaryString = atob(base64)
              const bytes = new Uint8Array(binaryString.length)
              for (let i = 0; i < binaryString.length; i++) {
                bytes[i] = binaryString.charCodeAt(i)
              }
              return bytes.buffer
            }
            fileBytes = base64ToArrayBuffer(doc.file_bytes)
          }

          let fileType = doc.file_type || "unknown"
          if (!fileType || fileType === "unknown") {
            const extension = (doc.title || "").split(".").pop().toLowerCase()
            if (extension === "pdf") fileType = "pdf"
            else if (["doc", "docx"].includes(extension)) fileType = "word"
            else if (["xls", "xlsx"].includes(extension)) fileType = "excel"
          }

          return {
            name: doc.title,
            bytes: fileBytes,
            type: fileType,
            id: doc.id,
            rejected_comment: doc.rejected_comment,
            masterdoc_type: doc?.masterdoc_type,
          }
        })
        console.log(newDocuments,"newDocumentsnewDocumentsnewDocuments")

        setDocumentList(newDocuments)
      }
    } catch (error) {
      // You may log or show error here
    } finally {
      setTabLoading((prev) => ({
        ...prev,
        [tabKey]: false,
      }))
    }
  }

  const getCategories = async (tabKey, search = "") => {
    try {
      const res = await sendRequest(`/user/categories`, "GET")
      if (res.data.type === "success") {
        setCategories(res.data.data)
      }
    } catch (error) {
      // You may log or show error here
    } finally {
    }
  }

  const getPageSelections = async () => {
    try {
      const res = await sendRequest(`/user/document-selections/${selectedDocument?.id}?update_doc=${id}`, "GET")
      if (res.data.type === "success") {
        setPageSelection(res.data.data)
      }
    } catch (error) {
      // You may log or show error here
    } finally {
    }
  }

  const handleCancel = () => {
    dispatch(callCommonAction({ alert: null }))
  }
  /********Before Delete*******/
  const confirmBeforeReset = (value) => {
    const custom = Alert.confirmReset(value, () => createNewPdf(value), handleCancel)
    dispatch(callCommonAction({ alert: custom }))
  }

  const createNewPdf = async (value) => {
    dispatch(callCommonAction({ alert: null }))
    try {
      setSelectedPagesToRemove({})
      setSelectedDocument(null)
      setIsIframeLoading(true)

      const { projectName = "", description = "" } = data || {}

      // Handle manualValue case (creates blank PDF)
      if (value === "manualValue") {
        setEditorContent("")
        setPdfBytes(null)

        setTimeout(async () => {
          const pdfDoc = await PDFDocument.create()
          pdfDoc.addPage([622.28, 842]) // A4 size
          const newBytes = await pdfDoc.save()

          setPdfBytes(newBytes)
          setCurrentPageIndex(0)
          setProposalsContents({})
          newPageContentRef.current = ""

          // Clear location state
          navigate(location.pathname, {
            replace: true,
            state: null,
          })

          // Mark first page as editable
          setProposalIsEditable((prev) => {
            const updated = [...prev]
            updated[0] = { isEditable: true, type: "true" }
            return updated
          })
        }, 100)

        return // Exit early for manualValue case
      }

      // Handle normal case with data
      const isAllFieldsFilled = projectName && description

      if (isAllFieldsFilled) {
        let processedHtml = await preloadImages(data)
        if (typeof processedHtml !== "string") {
          processedHtml = typeof description === "string" ? description : JSON.stringify(description)
        }
        const CUSTOM_PAGE_WIDTH = 616.28
        const CUSTOM_PAGE_HEIGHT = 841.89

        const tempDiv = document.createElement("div")
        tempDiv.innerHTML = `
  <div style="width: ${CUSTOM_PAGE_WIDTH}px; min-width: ${CUSTOM_PAGE_WIDTH}px; padding: 20px; font-family: Arial, sans-serif; font-size: 14px;">
    <h2 style="margin-bottom: 10px;">${projectName}</h2>
    ${processedHtml}
  </div>
`

        document.body.appendChild(tempDiv)

        await new Promise((resolve) => setTimeout(resolve, 500))

        const opt = {
          margin: 0,
          filename: "document.pdf",
          image: { type: "jpeg", quality: 0.98 },
          html2canvas: {
            scale: 2,
            useCORS: true,
            allowTaint: true,
            logging: false,
          },
          jsPDF: {
            unit: "pt",
            format: [CUSTOM_PAGE_WIDTH, CUSTOM_PAGE_HEIGHT], // ✅ must be number[]
            orientation: "portrait",
          },
        }

        const pdfBytes = await html2pdf().set(opt).from(tempDiv).outputPdf("arraybuffer")

        setPdfBytes(pdfBytes)
        setProposalsContents({})
        setCurrentPageIndex(0)

        const newPageIndex = 0
        setProposalIsEditable((prev) => {
          const updated = [...prev]
          updated[newPageIndex] = { isEditable: true, type: "true" }
          return updated
        })

        const htmlContent = `
          <h2>${projectName}</h2>
          ${processedHtml}
        `

        setUpdatedPageContents((prev) => [
          ...prev,
          {
            document_id: saveId || "",
            old_index: newPageIndex,
            new_index: newPageIndex,
            content: htmlContent,
          },
        ])

        if (value === undefined) {
          updateSelectedProposalContentWithHTML()
        }

        setEditorContent(htmlContent)
        tempDiv.remove()
        setShowModal(false)
      } else if (!id && !data) {
        // If data is undefined or incomplete, create blank page
        setEditorContent("")
        setPdfBytes(null)

        setTimeout(async () => {
          const pdfDoc = await PDFDocument.create()
          pdfDoc.addPage([622.28, 842])
          const newBytes = await pdfDoc.save()

          setPdfBytes(newBytes)
          setCurrentPageIndex(0)
          setProposalsContents({})
          newPageContentRef.current = ""

          setProposalIsEditable((prev) => {
            const updated = [...prev]
            updated[0] = { isEditable: true, type: "true" }
            return updated
          })
        }, 100)
      }
    } catch (error) {
      console.error("Error creating PDF:", error)
    } finally {
      setIsIframeLoading(false)
    }
  }

  const addNewPage = async () => {
    if (!pdfBytes) return

    // First update the selected proposal content
    await updateSelectedProposalContentWithHTML()
    setIsIframeLoading(true)

    try {
      const pdfDoc = await PDFDocument.load(pdfBytes)

      // A4 portrait size
      const A4_WIDTH = 616.28
      const A4_HEIGHT = 841.89

      // Calculate insert position (after current page)
      const insertPosition = currentPageIndex !== null ? currentPageIndex + 1 : pdfDoc.getPageCount()

      // Add a new page at the calculated position
      const newPage = pdfDoc.insertPage(insertPosition, [A4_WIDTH, A4_HEIGHT])

      // Save the updated PDF
      const newBytes = await pdfDoc.save()
      setPdfBytes(newBytes)

      // Shift existing content data to accommodate the new page
      const updatedContents = {}
      const updatedEditablePages = [...proposalIsEditable]

      // Shift all content from insertPosition onwards by 1
      Object.keys(proposalsContents).forEach((pageIndex) => {
        const index = Number.parseInt(pageIndex)
        if (index >= insertPosition) {
          // Shift content to next position
          updatedContents[index + 1] = proposalsContents[index]

          // Shift editable page info
          if (updatedEditablePages[index]) {
            updatedEditablePages[index + 1] = updatedEditablePages[index]
          }
        } else {
          // Keep content in same position
          updatedContents[index] = proposalsContents[index]
        }
      })

      // Set empty content for the new page
      updatedContents[insertPosition] = "<p></p>"
      updatedEditablePages[insertPosition] = {
        isEditable: true,
        type: "pdf",
      }

      // Update states
      setProposalsContents(updatedContents)
      setProposalIsEditable(updatedEditablePages)

      // Update the updatedPageContents array to reflect the shifts
      const newUpdatedPageContents = []

      // Add entry for the new empty page
      newUpdatedPageContents.push({
        document_id: saveId || "",
        old_index: insertPosition,
        new_index: insertPosition,
        content: "<p></p>",
      })

      // Update indices for shifted pages
      updatedPageContents.forEach((item) => {
        if (item.new_index >= insertPosition) {
          newUpdatedPageContents.push({
            ...item,
            new_index: item.new_index + 1,
          })
        } else {
          newUpdatedPageContents.push(item)
        }
      })

      setUpdatedPageContents(newUpdatedPageContents)

      // Set the current page index to the newly added page
      setCurrentPageIndex(insertPosition)

      // Set empty content for the editor
      setEditorContent("<p></p>")
      newPageContentRef.current = "<p></p>"

      // Update the editor if it exists
      if (editorRef.current) {
        editorRef.current.setData("<p></p>")
      }

      // Regenerate thumbnails to reflect the new page structure
      await generateThumbnails(newBytes)
    } catch (error) {
      console.error("Error adding new page:", error)
    } finally {
      setIsIframeLoading(false)
    }
  }

  // Helper function to shift proposal images when pages are added
  const shiftProposalImages = (images, insertPosition) => {
    const shiftedImages = {}

    Object.keys(images).forEach((pageIndex) => {
      const index = Number.parseInt(pageIndex)
      if (index >= insertPosition) {
        // Shift image to next position
        shiftedImages[index + 1] = images[index]
      } else {
        // Keep image in same position
        shiftedImages[index] = images[index]
      }
    })

    return shiftedImages
  }

  // Enhanced generateThumbnails function to handle shifted pages
  const generateThumbnails = async (pdfBytes) => {
    try {
      dispatch(callCommonAction({ loading5: true }))

      const pdfDoc = await PDFDocument.load(pdfBytes)
      const pageCount = pdfDoc.getPageCount()
      const images = {}

      for (let i = 0; i < pageCount; i++) {
        const imageData = await renderProposalAsImage(pdfBytes, i, "thumbnail")
        if (imageData) images[i] = imageData
      }

      setProposalImages(images)
    } catch (error) {
      console.error("Error generating thumbnails:", error)
    } finally {
      dispatch(callCommonAction({ loading5: false }))
    }
  }

  // Enhanced page selector to show correct page numbers after insertion
  const renderPageSelector = () => {
    if (!pdfBytes) return null

    return (
      <div className="mb-3">
        <label htmlFor="pageSelect" className="form-label">
          Select a page to edit
        </label>
        <div className="d-flex align-items-center">
          <select
            id="pageSelect"
            className="select-page form-select"
            disabled={isIframeLoading}
            value={currentPageIndex !== null ? currentPageIndex : ""}
            onChange={(e) => {
              const selectedPage = Number(e.target.value)
              setIsIframeLoading(true)
              setCurrentPageIndex(selectedPage)

              // Find content for the selected page
              const contentForPage = proposalsContents[selectedPage] || ""

              // Set editor content
              setEditorContent(contentForPage)
              newPageContentRef.current = contentForPage

              // If editor instance exists, update its content directly
              if (editorRef.current) {
                editorRef.current.setData(contentForPage)
              }

              setIsIframeLoading(false)
            }}
          >
            {Object.keys(proposalImages).map((pageIndex) => {
              const index = Number(pageIndex)
              return (
                <option key={index} value={index}>
                  Page {index + 1}
                </option>
              )
            })}
          </select>
          <button
            className="align-items-center btn btn-outline-custom btn-sm d-flex ms-2"
            onClick={addNewPage}
            title="Add new page after current page"
          >
            <iconify-icon icon="lucide:plus" class="fs-4 yellow"></iconify-icon>
          </button>
        </div>
      </div>
    )
  }

  // Modified download function to show popup instead of downloading directly
  const handleDownloadClick = () => {
    if (!pdfBytes) return
    setShowDownloadPopup(true)
  }

  /* Validation implemented here */
  const checkFormIsValid = (fieldName) => {
    const res = validateProposalFormData(documentProposalData, fieldName)
    setErrorsInfo(res.errors)
    return res.formValidCheck
  }

  const handleDownloadConfirm = async () => {
    if (!pdfBytes) return
    if (checkFormIsValid("")) {
      try {
        dispatch(callCommonAction({ loading7: true }))

        const blob = new Blob([pdfBytes], { type: "application/pdf" })
        const file = new File([blob], `${documentProposalData.title || "edited"}.pdf`, {
          type: "application/pdf",
        })

        const formData = new FormData()
        formData.append("title", documentProposalData?.title)
        formData.append("metatitle", documentProposalData?.metatitle || "")
        formData.append("file", file)
        formData.append("is_draft", documentProposalData?.is_draft === false ? "" : "1")
        formData.append("doc_data", JSON.stringify(updatedPageContents))

        // Add selected document ID
        if (selectedDocument?.id) {
          formData.append("document_id", selectedDocument.id)
        }

        // Get newly selected pages
        const selectedPages = Object.entries(selectedProposals)
          .filter(([_, value]) => value) // only selected = true
          .map(([key]) => Number.parseInt(key)) // get page indexes

        // Get previously selected pages (if any)
        const previouslySelectedPages = pageSelection?.selected_pages || []

        // Combine selections, ensuring we don't include duplicates
        // and respecting any pages that were unchecked
        const combinedPages = Array.from(new Set([...previouslySelectedPages, ...selectedPages]))

        // Add combined selected pages to payload
        formData.append("selected_pages", JSON.stringify(combinedPages))

        const apiUrl = saveId ? `/user/document/${saveId}` : "/user/document"
        // Use sendRequest but allow FormData
        const res = await sendRequest(apiUrl, "POST", formData, {
          headers: {
            "Content-Type": "multipart/form-data", // Optional; some libraries handle this automatically
          },
        })
        handleApiResponse(res)
        if (res.data.type === "success") {
          const isDraft = documentProposalData?.is_draft
          dispatch(callCommonAction({ loading7: false }))
          setDocumentProposalData({ title: "", metatitle: "", is_draft: false })
          if (!isDraft) {
            // Only navigate and download if NOT a draft
            navigate(appRoutes.listProposalRoute)
            saveAs(blob, documentProposalData.title ? `${documentProposalData.title}.pdf` : "edited.pdf")
            // Download file locally
            setUpdatedPageContents([])
            setEditorContent("")
          } else {
            navigate(appRoutes.listProposalRoute)
          }
          // Close popup
          setShowDownloadPopup(false)
        }
      } catch (error) {
        dispatch(callCommonAction({ loading7: false }))
        console.error("Error during download:", error)
      }
    }
  }

  const handleAutoSave = async () => {
    if (!pdfBytes) return
    try {
      dispatch(callCommonAction({ loading7: true }))

      const blob = new Blob([pdfBytes], { type: "application/pdf" })
      const file = new File([blob], `${documentProposalData.title || "edited"}.pdf`, {
        type: "application/pdf",
      })

      const formData = new FormData()
      formData.append("title", documentProposalData?.title || data.projectName)
      formData.append("metatitle", documentProposalData?.metatitle || "")
      formData.append("file", file)
      formData.append("is_draft", "1")
      formData.append("doc_data", JSON.stringify(updatedPageContents))

      const apiUrl = saveId ? `/user/document/${saveId}` : "/user/document"
      // Use sendRequest but allow FormData
      const res = await sendRequest(apiUrl, "POST", formData, {
        headers: {
          "Content-Type": "multipart/form-data", // Optional; some libraries handle this automatically
        },
      })
      if (res.data.type === "success") {
        const isDraft = documentProposalData?.is_draft
        dispatch(callCommonAction({ loading7: false }))

        // window.location.reload()
      }
    } catch (error) {
      dispatch(callCommonAction({ loading7: false }))
      console.error("Error during download:", error)
    }
  }

  // Convert Word/HTML to PDF
  const convertHtmlToPdf = async (htmlContent) => {
    // Create a temporary div to render the HTML
    const tempDiv = document.createElement("div")
    tempDiv.innerHTML = htmlContent
    tempDiv.style.width = "600px"
    tempDiv.style.padding = "20px"
    document.body.appendChild(tempDiv)

    // Wait for images to render
    await new Promise((resolve) => setTimeout(resolve, 500))

    // Convert to PDF
    const htmlPdfOptions = {
      margin: 10,
      filename: "temp.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: {
        scale: 2,
        useCORS: true,
        allowTaint: true,
        logging: true,
      },
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
    }

    try {
      const htmlPdfBlob = await html2pdf().from(tempDiv).set(htmlPdfOptions).outputPdf("blob")
      const htmlPdfArrayBuffer = await htmlPdfBlob.arrayBuffer()

      // Clean up
      document.body.removeChild(tempDiv)

      return htmlPdfArrayBuffer
    } catch (error) {
      console.error("Error converting HTML to PDF:", error)
      document.body.removeChild(tempDiv)
      throw error
    }
  }

  // Modify the handleDocumentSelect function to process different file types
  const handleDocumentSelect = async (e) => {
    setSelectAll(false)

    const selectedIndex = e.target.value
    if (selectedIndex === "") {
      setSelectedDocument(null)
      return
    }

    // Set view mode to thumbnails and show loader
    setViewMode("thumbnails")
    setThumbnailsLoading(true)
    setActiveDocumentName(documentList[Number.parseInt(selectedIndex)].name)

    // Reset any existing preview state when changing documents
    setPreviewImage(null)
    setCurrentPreviewDocBytes(null)
    setCurrentPreviewPageIdx(null)
    setCurrentPreviewDocIndex(null)

    const selectedDoc = documentList[Number.parseInt(selectedIndex)]
    console.log(documentList,"documentListdocumentListdocumentList")

    if (activeSection === "drafts") {
      navigate(`/update-proposal/${selectedDoc?.id}`)
      window.location.reload()
      return // Early return to prevent thumbnail generation for oldDocs
    }
    setSelectedDocument(selectedDoc)

    // Check if we have cached thumbnails for this document
    if (selectedDoc.id && thumbnailCache[selectedDoc.id]) {
      console.log(`Using cached thumbnails for document ${selectedDoc.id}`)

      // Update document pages map from cache
      const updatedPagesMap = { ...documentPagesMap }
      updatedPagesMap[selectedIndex] = thumbnailCache[selectedDoc.id].pages
      setDocumentPagesMap(updatedPagesMap)

      // Update document thumbnails map from cache
      const updatedImagesMap = { ...documentproposalImagesMap }
      updatedImagesMap[selectedIndex] = thumbnailCache[selectedDoc.id].images
      setDocumentproposalImagesMap(updatedImagesMap)

      // Restore processed content if available
      if (thumbnailCache[selectedDoc.id].processedContent) {
        selectedDoc.processedContent = thumbnailCache[selectedDoc.id].processedContent
      }

      setThumbnailsLoading(false)
      return // Skip further processing
    }
console.log(selectedDoc.type && selectedDoc.bytes,"selectedDoc.type && selectedDoc.bytes")
    // Process non-PDF documents to generate thumbnails and content
    if (selectedDoc.type && selectedDoc.bytes) {
      if (selectedDoc.type === "word" || selectedDoc.type === "docx" || selectedDoc.type === "doc") {
        // Process Word document
        dispatch(callCommonAction({ loading5: true }))
        try {
          const result = await processWordDocument(selectedDoc.bytes)

          // Update document pages map
          const updatedPagesMap = { ...documentPagesMap }
          updatedPagesMap[selectedIndex] = Array.from({ length: result.pageCount }, (_, i) => i)
          setDocumentPagesMap(updatedPagesMap)

          // Update document thumbnails map
          const updatedImagesMap = { ...documentproposalImagesMap }
          updatedImagesMap[selectedIndex] = result.thumbnails
          setDocumentproposalImagesMap(updatedImagesMap)

          // Store the content for later use
          selectedDoc.processedContent = result.contents

          // Save to cache if document has an ID
          if (selectedDoc.id) {
            setThumbnailCache((prevCache) => ({
              ...prevCache,
              [selectedDoc.id]: {
                pages: updatedPagesMap[selectedIndex],
                images: updatedImagesMap[selectedIndex],
                processedContent: result.contents,
              },
            }))
          }
        } catch (error) {
          console.error("Error processing Word document:", error)
        } finally {
          dispatch(callCommonAction({ loading5: false }))
          setThumbnailsLoading(false)
        }
      } else if (selectedDoc.type === "excel" || selectedDoc.type === "xlsx" || selectedDoc.type === "xls") {
        // Process Excel document
        dispatch(callCommonAction({ loading5: true }))
        try {
          const result = await processExcelDocument(selectedDoc.bytes)

          // Update document pages map
          const updatedPagesMap = { ...documentPagesMap }
          updatedPagesMap[selectedIndex] = Array.from({ length: result.pageCount }, (_, i) => i)
          setDocumentPagesMap(updatedPagesMap)

          // Update document thumbnails map
          const updatedImagesMap = { ...documentproposalImagesMap }
          updatedImagesMap[selectedIndex] = result.thumbnails
          setDocumentproposalImagesMap(updatedImagesMap)

          // Store the content for later use
          selectedDoc.processedContent = result.contents

          // Save to cache if document has an ID
          if (selectedDoc.id) {
            setThumbnailCache((prevCache) => ({
              ...prevCache,
              [selectedDoc.id]: {
                pages: updatedPagesMap[selectedIndex],
                images: updatedImagesMap[selectedIndex],
                processedContent: result.contents,
              },
            }))
          }
        } catch (error) {
          console.error("Error processing Excel document:", error)
        } finally {
          dispatch(callCommonAction({ loading5: false }))
          setThumbnailsLoading(false)
        }
      } else {
        // For PDF or other file types
        setThumbnailsLoading(false)
      }
    } else {
      setThumbnailsLoading(false)
    }
  }

  const backToDocumentList = () => {
    setViewMode("list")
    setSelectedDocument(null)
    setSelectedProposals({})
  }

  // Page rendering and thumbnails
  // Modify the renderProposalAsImage function to accept a scale parameter
  const renderProposalAsImage = async (pdfBytes, pageIndex, scale = 1.0) => {
    try {
      const loadingTask = pdfjs.getDocument({ data: pdfBytes })
      const pdf = await loadingTask.promise

      if (pageIndex >= pdf.numPages) return null

      const page = await pdf.getPage(pageIndex + 1)
      const viewport = page.getViewport({ scale: 1.0 })

      // Use the provided scale or calculate based on thumbnail size
      const finalScale = scale === "thumbnail" ? 100 / Math.max(viewport.width, viewport.height) : scale

      const scaledViewport = page.getViewport({ scale: finalScale })

      const canvas = document.createElement("canvas")
      const context = canvas.getContext("2d")
      if (!context) return null

      canvas.width = scaledViewport.width
      canvas.height = scaledViewport.height

      await page.render({
        canvasContext: context,
        viewport: scaledViewport,
      }).promise

      return canvas.toDataURL()
    } catch (error) {
      console.error("Error rendering PDF page:", error)
      return null
    }
  }

  // Prepare previewable images array for navigation
  const preparePreviewableImages = (docIndex, pageIdx) => {
    const images = []

    // If we're previewing from the current document
    if (docIndex === null && pdfBytes) {
      // Add all pages from the current document
      Object.keys(proposalImages).forEach((idx) => {
        images.push({
          imageUrl: proposalImages[idx],
          docBytes: pdfBytes,
          pageIdx: Number(idx),
          docIndex: null,
        })
      })
    }
    // If we're previewing from a selected document
    else if (docIndex !== null && documentList[docIndex]) {
      const docPages = documentPagesMap[docIndex] || []
      docPages.forEach((idx) => {
        images.push({
          imageUrl: documentproposalImagesMap[docIndex]?.[idx],
          docBytes: documentList[docIndex].bytes,
          pageIdx: idx,
          docIndex: docIndex,
        })
      })
    }

    return images
  }

  // Modified handleThumbnailPreview function to support navigation
  const handleThumbnailPreview = async (imageUrl, docBytes = null, pageIdx = null, docIndex = null, value) => {
    // Always reset the shouldHidePreview flag when opening a new preview
    setShouldHidePreview(value)

    setShowPreviewPopup(true)

    // Reset the current preview state to ensure we're showing the newly selected document
    setPreviewImage(null)
    setCurrentPreviewDocBytes(null)
    setCurrentPreviewPageIdx(null)
    setCurrentPreviewDocIndex(null)

    // Prepare array of all previewable images for navigation
    const images = preparePreviewableImages(docIndex, pageIdx)
    setPreviewableImages(images)

    // Find the index of the current image in the array
    const currentIndex = images.findIndex(
      (img) => img.pageIdx === pageIdx && (docIndex === null ? img.docIndex === null : img.docIndex === docIndex),
    )

    setCurrentPreviewImageIndex(currentIndex >= 0 ? currentIndex : 0)

    // First set the thumbnail as preview to show something immediately
    setPreviewImage(imageUrl)
    setCurrentPreviewDocBytes(docBytes)
    setCurrentPreviewPageIdx(pageIdx)
    setCurrentPreviewDocIndex(docIndex)

    // Reset selected images in preview
    setPreviewSelectedImages({})

    // If we have document bytes and page index, generate a high-res version
    if (docBytes && pageIdx !== null) {
      // Check if we already have a cached high-res version
      const cacheKey = `${docBytes}-${pageIdx}`
      if (highResPreviewCache[cacheKey]) {
        setPreviewImage(highResPreviewCache[cacheKey])
        return
      }

      try {
        dispatch(callCommonAction({ loading5: true }))

        // Attempt to generate high-res version (scale 2.0 for better quality)
        const highResImage = await renderProposalAsImage(docBytes, pageIdx, 2.0)
        if (highResImage) {
          setPreviewImage(highResImage)
          setHighResPreviewCache((prev) => ({
            ...prev,
            [cacheKey]: highResImage,
          }))
        }
      } catch (error) {
        console.error("Error generating high-res image:", error)
        dispatch(callCommonAction({ loading5: false }))

        // Handle error gracefully, e.g., show an error message or fallback
      } finally {
        dispatch(callCommonAction({ loading5: false }))

        // Optional: Any cleanup or state updates you want to perform regardless of success or failure
      }
    }
  }

  // Navigate to the next image in preview
  const navigateToNextPreviewImage = async () => {
    if (previewableImages.length <= 1) return

    const nextIndex = (currentPreviewImageIndex + 1) % previewableImages.length
    setCurrentPreviewImageIndex(nextIndex)

    const nextImage = previewableImages[nextIndex]

    // Update preview with the next image
    setPreviewImage(nextImage.imageUrl)
    setCurrentPreviewDocBytes(nextImage.docBytes)
    setCurrentPreviewPageIdx(nextImage.pageIdx)
    setCurrentPreviewDocIndex(nextImage.docIndex)

    // Generate high-res version if needed
    if (nextImage.docBytes && nextImage.pageIdx !== null) {
      const cacheKey = `${nextImage.docBytes}-${nextImage.pageIdx}`
      if (highResPreviewCache[cacheKey]) {
        setPreviewImage(highResPreviewCache[cacheKey])
      } else {
        const highResImage = await renderProposalAsImage(nextImage.docBytes, nextImage.pageIdx, 2.0)
        if (highResImage) {
          setPreviewImage(highResImage)
          setHighResPreviewCache((prev) => ({
            ...prev,
            [cacheKey]: highResImage,
          }))
        }
      }
    }
  }

  // Navigate to the previous image in preview
  const navigateToPrevPreviewImage = async () => {
    if (previewableImages.length <= 1) return

    const prevIndex = (currentPreviewImageIndex - 1 + previewableImages.length) % previewableImages.length
    setCurrentPreviewImageIndex(prevIndex)

    const prevImage = previewableImages[prevIndex]

    // Update preview with the previous image
    setPreviewImage(prevImage.imageUrl)
    setCurrentPreviewDocBytes(prevImage.docBytes)
    setCurrentPreviewPageIdx(prevImage.pageIdx)
    setCurrentPreviewDocIndex(prevImage.docIndex)

    // Generate high-res version if needed
    if (prevImage.docBytes && prevImage.pageIdx !== null) {
      const cacheKey = `${prevImage.docBytes}-${prevImage.pageIdx}`
      if (highResPreviewCache[cacheKey]) {
        setPreviewImage(highResPreviewCache[cacheKey])
      } else {
        const highResImage = await renderProposalAsImage(prevImage.docBytes, prevImage.pageIdx, 2.0)
        if (highResImage) {
          setPreviewImage(highResImage)
          setHighResPreviewCache((prev) => ({
            ...prev,
            [cacheKey]: highResImage,
          }))
        }
      }
    }
  }

  // Toggle selection of the current preview image
  const togglePreviewImageSelection = () => {
    if (currentPreviewPageIdx === null) return

    const key = `${currentPreviewDocIndex}-${currentPreviewPageIdx}`
    setPreviewSelectedImages((prev) => ({
      ...prev,
      [key]: !prev[key],
    }))
  }

  // Add this helper function to validate PDF bytes before attempting to load them
  const validatePdfBytes = async (bytes) => {
    try {
      // Check for PDF header signature (%PDF-)
      if (bytes instanceof ArrayBuffer) {
        const arr = new Uint8Array(bytes, 0, 5)
        const header = String.fromCharCode.apply(null, arr)
        if (header !== "%PDF-") {
          return false
        }
      }

      // Try loading with PDFDocument as a secondary validation
      await PDFDocument.load(bytes)
      return true
    } catch (error) {
      console.error("PDF validation failed:", error)
      return false
    }
  }

  console.log(selectedDocument, "aselectedDoc")

  const insertSelectedPreviewImages = async () => {
    if (!pdfBytes) return
    setShowPreviewPopup(false)
    setIsIframeLoading(true)

    try {
      dispatch(callCommonAction({ loading2: true }))
      setIsProcessing(true)

      const selectedKeys = Object.keys(previewSelectedImages).filter((key) => previewSelectedImages[key])

      if (selectedKeys.length === 0) {
        if (currentPreviewDocBytes && currentPreviewPageIdx !== null) {
          await insertPreviewImage(currentPreviewDocBytes, currentPreviewPageIdx, currentPreviewDocIndex, "pdf", true)
        }
      } else {
        for (const key of selectedKeys) {
          const [docIndexStr, pageIdxStr] = key.split("-")
          const docIndex = docIndexStr === "null" ? null : Number(docIndexStr)
          const pageIdx = Number(pageIdxStr)

          let docBytes
          let docType = "pdf"

          if (docIndex === null) {
            docBytes = pdfBytes
          } else if (documentList[docIndex]) {
            docBytes = documentList[docIndex].bytes
            docType = documentList[docIndex].type
          }

          if (docBytes) {
            try {
              await insertPreviewImage(docBytes, pageIdx, docIndex, docType, true)
            } catch (insertError) {
              console.error("Error inserting page:", insertError)
            }
          }
        }
      }

      // setPreviewSelectedImages({})
      // setSelectedProposals({})
    } catch (error) {
      console.error("Error inserting selected preview images:", error)
    } finally {
      dispatch(callCommonAction({ loading2: false }))
      setIsProcessing(false)
      setIsIframeLoading(false)
      setSelectedProposals({})
    }
  }

  const handleButtonClick = () => {
    setShowModal(true) // Show the modal when the button is clicked
  }
  const handleUserAddDoc = () => {
    setShowUserDocumentPopup(true)
    setSelectedDocumentId(null) // Set the document to edit
  }
  const insertPreviewImage = async (docBytes, pageIdx, docIndex, docType = "pdf", renderAsImage = true) => {
    try {
      const currentPdfDoc = await PDFDocument.load(pdfBytes)
      const insertPosition = currentPageIndex !== null ? currentPageIndex + 1 : currentPdfDoc.getPageCount()

      let copiedPage
      let htmlContent = null

      if (docType === "pdf") {
        if (await validatePdfBytes(docBytes)) {
          const selectedPdfDoc = await PDFDocument.load(docBytes)

          if (pageIdx < 0 || pageIdx >= selectedPdfDoc.getPageCount()) {
            throw new Error(`Invalid page index: ${pageIdx}. Document has ${selectedPdfDoc.getPageCount()} pages.`)
          }
          // ✅ Copy the page first
          ;[copiedPage] = await currentPdfDoc.copyPages(selectedPdfDoc, [pageIdx])
          const { width, height } = copiedPage.getSize()
          copiedPage.setSize(width, height)

          // ✅ Insert copied page into current doc
          currentPdfDoc.insertPage(insertPosition, copiedPage)

          if (masterDocIds.includes(selectedDocument?.id)) {
            console.log(selectedDocument,"selectedDocumentselectedDocument")
            try {
              console.log("adasdasda")

              const res = await sendRequest(`/user/get-master-doc/${selectedDocument?.id}`, "GET")

              if (res.data.type === "success") {
                const fetchedContent = res.data.data

                // ✅ Use insertPosition for correct placement
                setProposalsContents((prevContents) => ({
                  ...prevContents,
                  [insertPosition]: fetchedContent,
                }))

                setProposalIsEditable((prev) => {
                  const updated = [...prev]
                  updated[insertPosition] = { isEditable: true, type: true }
                  return updated
                })

                setUpdatedPageContents((prev) => [
                  ...prev,
                  {
                    document_id: saveId || "",
                    old_index: pageIdx,
                    new_index: insertPosition,
                    content: fetchedContent,
                  },
                ])
              }
            } catch (error) {
              console.error("Failed to fetch master doc content:", error)
            }
          } else if (renderAsImage) {
            if (renderAsImage) {
              // ✅ Only run this if not 283
              const imageData = await renderProposalAsImage(docBytes, pageIdx, 2.0)
              if (imageData) {
                htmlContent = `<div class="inserted-page-content">
              <img src="${imageData}" style="width: 100%; margin-top: 20px; border: 1px solid #ddd;" />
            </div>`

                setProposalsContents((prevContents) => ({
                  ...prevContents,
                  [insertPosition]: htmlContent,
                }))

                setProposalIsEditable((prev) => {
                  const updated = [...prev]
                  updated[insertPosition] = { isEditable: true, type: docType }
                  return updated
                })

                setUpdatedPageContents((prev) => [
                  ...prev,
                  {
                    document_id: saveId || "",
                    old_index: pageIdx,
                    new_index: insertPosition,
                    content: htmlContent,
                  },
                ])
                // ✅ Auto-jump to the inserted page
                if (insertPosition >= 0) {
                  setCurrentPageIndex(insertPosition)

                  const insertedContent = htmlContent || proposalsContents?.[insertPosition] || ""
                  setEditorContent(insertedContent)
                  newPageContentRef.current = insertedContent

                  if (editorRef.current) {
                    editorRef.current.setData(insertedContent)
                  }
                }
              }
            }
          }
        } else {
          throw new Error("Invalid PDF data")
        }
      } else if (["word", "doc", "docx", "excel", "xls", "xlsx"].includes(docType)) {
        const doc = docIndex !== null ? documentList[docIndex] : null
        if (doc && doc.processedContent && doc.processedContent[pageIdx]) {
          htmlContent = doc.processedContent[pageIdx]
          const pdfArrayBuffer = await convertHtmlToPdf(htmlContent)
          const convertedPdfDoc = await PDFDocument.load(pdfArrayBuffer)
          ;[copiedPage] = await currentPdfDoc.copyPages(convertedPdfDoc, [0])

          currentPdfDoc.insertPage(insertPosition, copiedPage)

          setProposalsContents((prev) => ({
            ...prev,
            [insertPosition]: htmlContent,
          }))

          setProposalIsEditable((prev) => {
            const updated = [...prev]
            updated[insertPosition] = { isEditable: true, type: docType }
            return updated
          })
        } else {
          throw new Error(`${docType} content not available`)
        }
      } else {
        throw new Error(`Unsupported document type: ${docType}`)
      }

      const newBytes = await currentPdfDoc.save()
      setPdfBytes(newBytes)
    } catch (error) {
      console.error("Error inserting preview image:", error)
      throw error
    }
  }

  // FIXED: Improved loadProposalFromData function to properly load and display PDF
  const loadProposalFromData = async (proposalData) => {
    console.log(proposalData,"proposa;dataaaaaaaaaaaa")
    try {
      setIsIframeLoading(true)
      dispatch(callCommonAction({ loading: true }))

      const documentData = {
        title: proposalData.title || "",
        metatitle: proposalData.metatitle || "",
        is_draft: proposalData.status === "0" || false,
      }
      setDocumentProposalData(documentData)

      let pdfBytes = null

      // 1. Try loading from base64 file_bytes
      if (proposalData.file_bytes) {
        const base64ToArrayBuffer = (base64) => {
          // Clean the base64 string if it has a data URL prefix
          const base64String = base64.replace(/^data:application\/pdf;base64,/, "")

          try {
            const binaryString = atob(base64String)
            const len = binaryString.length
            const bytes = new Uint8Array(len)

            for (let i = 0; i < len; i++) {
              bytes[i] = binaryString.charCodeAt(i)
            }

            return bytes.buffer
          } catch (err) {
            console.error("Error in base64 decoding:", err)
            throw err
          }
        }

        try {
          const fileBuffer = base64ToArrayBuffer(proposalData.file_bytes)

          pdfBytes = fileBuffer
        } catch (err) {
          console.error("Base64 decode failed, fallback to presigned_url", err)
        }
      }

      // 2. If no file_bytes, try fetching from presigned_url
      if (!pdfBytes && proposalData.presigned_url) {
        try {
          const response = await fetch(proposalData.presigned_url, {
            method: "GET",
            credentials: "include",
            headers: { Accept: "application/pdf" },
          })

          if (!response.ok) throw new Error("Failed to fetch PDF")

          pdfBytes = await response.arrayBuffer()
        } catch (fetchError) {
          console.error("PDF fetch failed:", fetchError)
          return
        }
      }

      // 3. If we have valid bytes now, load with pdf-lib
      if (pdfBytes) {
        try {
          // Validate PDF before loading
          if (await validatePdfBytes(pdfBytes)) {
            // Load the PDF document
            const loadedPdfDoc = await PDFDocument.load(pdfBytes)

            // Get total pages
            const totalPages = loadedPdfDoc.getPageCount()

            // Save the PDF bytes to state
            const savedBytes = await loadedPdfDoc.save()
            setPdfBytes(savedBytes)

            // Initialize content for each page
            const initialContents = {}
            for (let i = 0; i < totalPages; i++) {
              initialContents[i] = ""
            }
            setProposalsContents(initialContents)

            // Set current page to the first page
            setCurrentPageIndex(0)
          } else {
            throw new Error("Invalid PDF data")
          }
        } catch (pdfLoadErr) {
          console.error("Error parsing PDF with pdf-lib:", pdfLoadErr)
        }
      } else {
        console.warn("No valid PDF data found to load.")
      }
    } catch (error) {
      console.error("Unhandled error:", error)
    } finally {
      setIsIframeLoading(false)

      dispatch(callCommonAction({ loading: false }))
    }
  }

  // Add this function to close the preview popup
  const closePreviewPopup = () => {
    setShowPreviewPopup(false)
    setPreviewImage(null)
    setPreviewSelectedImages({})
  }

  // Modify the generateThumbnails function to use the scale parameter
  // const generateThumbnails = async (pdfBytes) => {
  //   try {
  //     dispatch(callCommonAction({ loading5: true }))

  //     const pdfDoc = await PDFDocument.load(pdfBytes)
  //     const pageCount = pdfDoc.getPageCount()
  //     const images = {}

  //     for (let i = 0; i < pageCount; i++) {
  //       const imageData = await renderProposalAsImage(pdfBytes, i, "thumbnail")
  //       if (imageData) images[i] = imageData
  //     }

  //     setProposalImages(images)
  //   } catch (error) {
  //     dispatch(callCommonAction({ loading5: false }))
  //     console.error("Error generating thumbnails:", error)
  //   } finally {
  //     dispatch(callCommonAction({ loading5: false }))
  //   }
  // }

  const clearThumbnailCache = (docId = null) => {
    if (docId) {
      // Clear cache for a specific document
      setThumbnailCache((prevCache) => {
        const newCache = { ...prevCache }
        delete newCache[docId]
        return newCache
      })
    } else {
      // Clear entire cache
      setThumbnailCache({})
    }
  }

  // Modified generateAllDocumentThumbnails function to handle different file types
  const generateAllDocumentThumbnails = async () => {
    // Skip thumbnail generation if we're in the oldDocs section

    const pagesMap = {}
    const imagesMap = {}

    for (let docIndex = 0; docIndex < documentList.length; docIndex++) {
      try {
        dispatch(callCommonAction({ loading5: true }))

        const doc = documentList[docIndex]

        // Check if document thumbnails are already in cache
        if (thumbnailCache[doc.id]) {
          console.log(`Using cached thumbnails for document ${doc.id}`)
          pagesMap[docIndex] = thumbnailCache[doc.id].pages
          imagesMap[docIndex] = thumbnailCache[doc.id].images

          // If we have processed content in cache, restore it
          if (thumbnailCache[doc.id].processedContent) {
            doc.processedContent = thumbnailCache[doc.id].processedContent
          }

          continue // Skip processing this document
        }

        // Check if document has bytes before processing
        if (!doc.bytes) {
          console.warn(`Document at index ${docIndex} has no bytes data`)
          pagesMap[docIndex] = [0]
          imagesMap[docIndex] = {
            0: generateNonPdfThumbnail(doc.type || "unknown"),
          }
          continue
        }

        // Check file type before trying to load as PDF
        if (doc.type === "pdf") {
          // Handle PDF files
          try {
            // Validate PDF before processing
            if (await validatePdfBytes(doc.bytes)) {
              const pdfDoc = await PDFDocument.load(doc.bytes)
              const pageCount = pdfDoc.getPageCount()

              pagesMap[docIndex] = Array.from({ length: pageCount }, (_, i) => i)

              const docImages = {}
              for (let i = 0; i < pageCount; i++) {
                const imageData = await renderProposalAsImage(doc.bytes, i, "thumbnail")
                if (imageData) docImages[i] = imageData
              }
              imagesMap[docIndex] = docImages
            } else {
              throw new Error("Invalid PDF data")
            }
          } catch (error) {
            console.error(`Error processing PDF document at index ${docIndex}:`, error)
            // Create a placeholder for this document
            pagesMap[docIndex] = [0] // Just one page
            imagesMap[docIndex] = {
              0: generateNonPdfThumbnail("pdf"), // Use PDF placeholder
            }
          }
        } else if (doc.type === "excel" || doc.type === "xlsx" || doc.type === "xls") {
          // For Excel files, process to get actual sheets
          try {
            const result = await processExcelDocument(doc.bytes)
            pagesMap[docIndex] = Array.from({ length: result.pageCount }, (_, i) => i)
            imagesMap[docIndex] = result.thumbnails
            doc.processedContent = result.contents
          } catch (error) {
            console.error(`Error processing Excel document at index ${docIndex}:`, error)
            pagesMap[docIndex] = [0]
            imagesMap[docIndex] = {
              0: generateNonPdfThumbnail("excel"),
            }
          }
        } else if (doc.type === "word" || doc.type === "docx" || doc.type === "doc") {
          // For Word files, process to get actual pages
          try {
            const result = await processWordDocument(doc.bytes)
            pagesMap[docIndex] = Array.from({ length: result.pageCount }, (_, i) => i)
            imagesMap[docIndex] = result.thumbnails
            doc.processedContent = result.contents
          } catch (error) {
            console.error(`Error processing Word document at index ${docIndex}:`, error)
            pagesMap[docIndex] = [0]
            imagesMap[docIndex] = {
              0: generateNonPdfThumbnail("word"),
            }
          }
        } else {
          // For unknown file types, create a placeholder
          pagesMap[docIndex] = [0]
          imagesMap[docIndex] = {
            0: generateNonPdfThumbnail(doc.type || "unknown"),
          }
        }

        // Save to cache if document has an ID
        if (doc.id) {
          setThumbnailCache((prevCache) => ({
            ...prevCache,
            [doc.id]: {
              pages: pagesMap[docIndex],
              images: imagesMap[docIndex],
              processedContent: doc.processedContent,
            },
          }))
        }
      } catch (error) {
        dispatch(callCommonAction({ loading5: false }))
        console.error(`Error processing document at index ${docIndex}:`, error)

        // Create a placeholder for this document
        pagesMap[docIndex] = [0]
        imagesMap[docIndex] = {
          0: generateNonPdfThumbnail("unknown"),
        }
      } finally {
        dispatch(callCommonAction({ loading5: false }))
      }
    }

    setDocumentPagesMap(pagesMap)
    setDocumentproposalImagesMap(imagesMap)
  }

  const insertSelectedPagesOnSamePage = async () => {
    if (!pdfBytes || !selectedDocument || !selectedProposals) return

    setIsIframeLoading(true)

    try {
      dispatch(callCommonAction({ loading9: true }))
      setIsProcessing(true)

      const selectedPageIndexes = Object.keys(selectedProposals).filter((key) => selectedProposals[key])

      if (selectedPageIndexes.length === 0 || currentPageIndex === null) {
        setIsProcessing(false)

        return // Exit if no pages are selected or no current page
      }

      // Get the current editor content
      const currentContent = newPageContentRef.current || ""

      // Create a container for all content
      let combinedContent = currentContent

      // Handle different file types (PDF, Word, Excel)
      if (selectedDocument.type === "pdf") {
        try {
          // For PDF files, we'll need to render them to images and insert as HTML
          if (await validatePdfBytes(selectedDocument.bytes)) {
            const selectedPdfDoc = await PDFDocument.load(selectedDocument.bytes)

            // Loop through all selected pages for this document
            for (const pageIndexString of selectedPageIndexes) {
              const pageIndex = Number.parseInt(pageIndexString)

              // Get the actual page size from the PDF
              const page = selectedPdfDoc.getPage(pageIndex)
              const { width, height } = page.getSize()
              console.log(width, height, "Heihg width")
              if (masterDocIds.includes(selectedDocument?.id)) {
            console.log(selectedDocument,"selectedDocumentselectedDocument")

                console.log("123213123")
                try {
                  const res = await sendRequest(`/user/get-master-doc/${selectedDocument?.id}`, "GET")

                  if (res.data.type === "success") {
                    const fetchedContent = res.data.data

                    // ✅ Append to combinedContent
                    combinedContent += `
              <div class="inserted-page-content">
                ${fetchedContent}
              </div>`

                    // ✅ Update state
                    setProposalsContents((prevContents) => ({
                      ...prevContents,
                      [pageIndex]: combinedContent,
                    }))

                    setProposalIsEditable((prev) => {
                      const updated = [...prev]
                      updated[pageIndex] = { isEditable: true, type: true }
                      return updated
                    })

                    setUpdatedPageContents((prev) => [
                      ...prev,
                      {
                        document_id: saveId || "",
                        old_index: pageIndex,
                        new_index: pageIndex,
                        content: combinedContent,
                      },
                    ])
                  } else {
                    console.warn("Unexpected response type", res.data)
                  }
                } catch (error) {
                  console.error("Failed to fetch master doc content:", error)
                }
              } else {
                const pageImage = await renderProposalAsImage(selectedDocument.bytes, pageIndex, 2.0)

                if (pageImage) {
                  combinedContent += `
                  <div class="inserted-page-content " 
                      style=" width: ${width}px; max-width: ${width}px; margin: 20px auto; border: 1px solid #ddd; page-break-after: always;"
                              margin: 20px auto; border: 1px solid #ddd; page-break-after: always;">
                    <img src="${pageImage}" 
                         style="width: 100%; height: auto; display: block;" />
                  </div>`

                  // Update the page contents in state
                  setProposalsContents((prevContents) => ({
                    ...prevContents,
                    [pageIndex]: combinedContent,
                  }))

                  // Mark this page as editable
                  setProposalIsEditable((prev) => {
                    const updated = [...prev]
                    updated[pageIndex] = { isEditable: true, type: true }
                    return updated
                  })

                  // setUpdatedPageContents((prev) => [
                  //   ...prev,
                  //   {
                  //     document_id: saveId || "",
                  //     old_index: pageIndex,
                  //     new_index: pageIndex, // assuming new_index is the same as pageIndex
                  //     content: combinedContent,
                  //   },
                  // ]);
                }
              }
            }
          }
        } catch (error) {
          console.error("Error inserting PDF page:", error)
        }
      } else if (
        selectedDocument.type === "excel" ||
        selectedDocument.type === "xlsx" ||
        selectedDocument.type === "xls" ||
        selectedDocument.type === "word" ||
        selectedDocument.type === "docx" ||
        selectedDocument.type === "doc"
      ) {
        // For Word and Excel files, directly insert the HTML content
        try {
          // Loop through all selected pages for this document
          for (const pageIndexString of selectedPageIndexes) {
            const pageIndex = Number.parseInt(pageIndexString)
            const content = selectedDocument.processedContent?.[pageIndex]

            if (content) {
              // Add the content with a separator
              combinedContent += `<div class="inserted-page-content" style="margin-top: 20px; border-top: 1px dashed #ccc; padding-top: 10px;   width: 614.28px;
  min-height: 841.89px;">
                ${content}
              </div>`

              // Update the page contents in state
              setProposalsContents((prevContents) => ({
                ...prevContents,
                [pageIndex]: combinedContent,
              }))

              // Mark this page as editable
              setProposalIsEditable((prev) => {
                const updated = [...prev]
                updated[pageIndex] = { isEditable: true, type: true }
                return updated
              })

              setUpdatedPageContents((prev) => [
                ...prev,
                {
                  document_id: saveId || "",
                  old_index: pageIndex,
                  new_index: pageIndex, // assuming new_index is the same as pageIndex
                  content: combinedContent,
                },
              ])
            }
          }
        } catch (error) {
          console.error(`Error inserting ${selectedDocument.type} page:`, error)
        }
      }

      // Update the editor with the combined content
      if (editorRef.current) {
        editorRef.current.setData(combinedContent)
        newPageContentRef.current = combinedContent
      }

      // Clear the selected proposals after insertion
      setSelectedProposals({})

      // Now automatically update the PDF with the new content
      await updateSelectedProposalContentWithHTML()
    } catch (error) {
      console.error("Error inserting pages on same page:", error)
    } finally {
      dispatch(callCommonAction({ loading9: false }))
      setIsProcessing(false)
      setIsIframeLoading(false)
    }
  }

  // HTML to PDF conversion
  const preloadImages = async (htmlContent) => {
    const tempDiv = document.createElement("div")
    tempDiv.innerHTML = htmlContent
    const images = tempDiv.querySelectorAll("img")

    if (images.length === 0) return htmlContent

    const imagePromises = Array.from(images).map((img) => {
      return new Promise((resolve) => {
        if (img.src.startsWith("http")) {
          const canvas = document.createElement("canvas")
          const ctx = canvas.getContext("2d")
          if (!ctx) {
            resolve()
            return
          }

          const newImg = new Image()
          newImg.crossOrigin = "anonymous"

          newImg.onload = () => {
            canvas.width = newImg.width
            canvas.height = newImg.height
            ctx.drawImage(newImg, 0, 0)

            try {
              const dataUrl = canvas.toDataURL("image/png")
              img.src = dataUrl
            } catch (err) {
              console.warn("Could not convert image to data URL:", err)
            }
            resolve()
          }

          newImg.onerror = () => {
            console.warn("Could not load image:", img.src)
            resolve()
          }

          newImg.src = img.src
        } else {
          resolve()
        }
      })
    })

    await Promise.all(imagePromises)
    return tempDiv.innerHTML
  }

  const updateSelectedProposalContentWithHTML = async () => {
    const data = newPageContentRef.current
    if (!data || data.trim() === "" || data.trim() === "<p>&nbsp;</p>") {
      setCkeContentError("Please fill this field.")
      return
    }
    setCkeContentError("") // Clear error if content is valid
    if (!pdfBytes || currentPageIndex === null || !data) return
    setIsIframeLoading(true)

    try {
      dispatch(callCommonAction({ loading1: true }))
      setIsProcessing(true)

      // Save old content before update
      const oldContent = proposalsContents[currentPageIndex]

      // Process HTML content
      const processedHtml = await preloadImages(data)
      const tempDiv = document.createElement("div")
      tempDiv.innerHTML = processedHtml
      tempDiv.style.width = "auto"
      tempDiv.style.padding = "20px"
      document.body.appendChild(tempDiv)

      // Wait for images to render
      await new Promise((resolve) => setTimeout(resolve, 500))

      const CUSTOM_PAGE_WIDTH = 616.28
      const CUSTOM_PAGE_HEIGHT = 841.89
      // Convert to PDF
      const htmlPdfOptions = {
        margin: 10,
        filename: "temp.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: {
          scale: 2,
          useCORS: true,
          allowTaint: true,
          logging: true,
        },
        jsPDF: {
          unit: "pt",
          format: [CUSTOM_PAGE_WIDTH, CUSTOM_PAGE_HEIGHT], // ✅ must be number[]
          orientation: "portrait",
        },
      }

      const htmlPdfBlob = await html2pdf().from(tempDiv).set(htmlPdfOptions).outputPdf("blob")
      const htmlPdfArrayBuffer = await htmlPdfBlob.arrayBuffer()

      const htmlPdfDoc = await PDFDocument.load(htmlPdfArrayBuffer)
      const currentPdfDoc = await PDFDocument.load(pdfBytes)
      const [htmlPage] = await currentPdfDoc.copyPages(htmlPdfDoc, [0])

      if (currentPageIndex < currentPdfDoc.getPageCount()) {
        currentPdfDoc.removePage(currentPageIndex)
        currentPdfDoc.insertPage(currentPageIndex, htmlPage)
      } else {
        currentPdfDoc.addPage(htmlPage)
      }

      const newBytes = await currentPdfDoc.save()
      setPdfBytes(newBytes)

      setUpdatedPageContents((prev) => {
        const index = prev.findIndex((item) => item.old_index === currentPageIndex)

        if (index !== -1) {
          // Update existing page
          const updated = [...prev]
          updated[index] = {
            ...updated[index],
            new_index: currentPageIndex,
            content: data,
          }
          return updated
        } else {
          // New page insert or first-time update
          return [
            ...prev,
            {
              document_id: saveId || "", // set real ID if you have it
              old_index: currentPageIndex,
              new_index: currentPageIndex,
              content: data,
            },
          ]
        }
      })

      // Update page content in state
      setProposalsContents((prevContents) => ({
        ...prevContents,
        [currentPageIndex]: data,
      }))

      // Update hasImageData state based on the new content
      setHasImageData(checkForImageData(data))

      document.body.removeChild(tempDiv)
    } catch (error) {
      setIsIframeLoading(false)
      dispatch(callCommonAction({ loading1: false }))
      console.error("Error updating page with HTML content:", error)
    } finally {
      dispatch(callCommonAction({ loading1: false }))
      setIsProcessing(false)
      setIsIframeLoading(false)
    }
  }

  const handleChange = (e) => {
    // Only update the raw input value, not the metatitle directly
    setRawInput(e.target.value)
  }

  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === "," || e.key === " ") {
      e.preventDefault()
      const tagValue = rawInput.trim()

      // Check if the input is not empty and the tag doesn't already exist
      if (tagValue && !tags.includes(tagValue)) {
        // Add the new tag to the list
        const updatedTags = [...tags, tagValue]
        setTags(updatedTags)

        // Update the metatitle with the new tag list
        updateMetaTitleField(updatedTags)

        // Clear the raw input
        setRawInput("")
      }
    }
  }

  const updateMetaTitleField = (tagList) => {
    setDocumentProposalData((prev) => ({
      ...prev,
      metatitle: tagList.join(","), // Join the tags into a comma-separated string
    }))
  }

  const removeTag = (tagToRemove, e) => {
    e.preventDefault()
    e.stopPropagation()

    // Remove the selected tag
    const updatedTags = tags.filter((tag) => tag !== tagToRemove)
    setTags(updatedTags)

    // Update the metatitle with the remaining tags
    updateMetaTitleField(updatedTags)
  }
  const insertMultipleProposalsFromSelectedDocument = async () => {
    if (!pdfBytes || !selectedDocument || !selectedProposals) return

    // Custom page dimensions
    const CUSTOM_PAGE_WIDTH = 616.28
    const CUSTOM_PAGE_HEIGHT = 841.89

    // PDF generation options
    // Convert to PDF
    const htmlPdfOptions = {
      margin: 10,

      filename: "temp.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: {
        scale: 2,
        useCORS: true,
        allowTaint: true,
        logging: true,
      },
      jsPDF: {
        unit: "pt",
        format: [CUSTOM_PAGE_WIDTH, CUSTOM_PAGE_HEIGHT], // ✅ must be number[]
        orientation: "portrait",
      },
    }

    setIsIframeLoading(true)

    try {
      dispatch(callCommonAction({ loading2: true }))
      setIsProcessing(true)

      const selectedPageIndexes = Object.keys(selectedProposals).filter((key) => selectedProposals[key])

      if (selectedPageIndexes.length === 0) {
        setIsProcessing(false)
        return
      }

      const currentContent = newPageContentRef.current || ""
      const currentPdfDoc = await PDFDocument.load(pdfBytes)
      let insertPosition = currentPageIndex !== null ? currentPageIndex + 1 : currentPdfDoc.getPageCount()

      if (selectedDocument.type === "pdf") {
        try {
          if (await validatePdfBytes(selectedDocument.bytes)) {
            const selectedPdfDoc = await PDFDocument.load(selectedDocument.bytes)

            for (const pageIndexString of selectedPageIndexes) {
              const pageIndex = Number.parseInt(pageIndexString)
              const copiedPages = await currentPdfDoc.copyPages(selectedPdfDoc, [pageIndex])

              for (const copiedPage of copiedPages) {
                const { width, height } = copiedPage.getSize()
                copiedPage.setSize(width, height)
                currentPdfDoc.insertPage(insertPosition, copiedPage)

                const actualInsertIndex = insertPosition

                if (masterDocIds.includes(selectedDocument?.id)) {
            console.log(selectedDocument,"selectedDocumentselectedDocument")

                  console.log("86867868")
                  try {
                    const res = await sendRequest(`/user/get-master-doc/${selectedDocument?.id}`, "GET")
                    console.log("res.data", res.data)

                    if (res.data.type === "success") {
                      const fetchedContent = res.data.data

                      // Update all states in correct order with latest values
                      setProposalsContents((prevContents) => ({
                        ...prevContents,
                        [actualInsertIndex]: (prevContents?.[actualInsertIndex] || "") + fetchedContent,
                      }))

                      setProposalIsEditable((prev) => {
                        const updated = [...prev]
                        updated[actualInsertIndex] = { isEditable: true, type: true }
                        return updated
                      })

                      setUpdatedPageContents((prev) => {
                        // Avoid duplicate updates by checking if content already exists
                        const alreadyExists = prev.some(
                          (item) =>
                            item.document_id === (saveId || "") &&
                            item.old_index === pageIndex &&
                            item.new_index === actualInsertIndex &&
                            item.content === fetchedContent,
                        )
                        if (alreadyExists) return prev

                        return [
                          ...prev,
                          {
                            document_id: saveId || "",
                            old_index: pageIndex,
                            new_index: actualInsertIndex,
                            content: fetchedContent,
                          },
                        ]
                      })
                    }
                  } catch (error) {
                    console.error("Failed to fetch master doc content:", error)
                  }
                } else {
                  // 🔁 Standard behavior with page image
                  const pageImage = await renderProposalAsImage(selectedDocument.bytes, pageIndex, 2.0)

                  if (pageImage) {
                    const pageHtmlContent = `
                <div class="inserted-page-content">
                  <img src="${pageImage}" style="width: 100%; margin-top: 20px; border: 1px solid #ddd;" />
                </div>`

                    setProposalsContents((prevContents) => ({
                      ...prevContents,
                      [actualInsertIndex]: (prevContents?.[actualInsertIndex] || "") + pageHtmlContent,
                    }))

                    setProposalIsEditable((prev) => {
                      const updated = [...prev]
                      updated[actualInsertIndex] = { isEditable: true, type: true }
                      return updated
                    })

                    setUpdatedPageContents((prev) => [
                      ...prev,
                      {
                        document_id: saveId || "",
                        old_index: pageIndex,
                        new_index: actualInsertIndex,
                        content: pageHtmlContent,
                      },
                    ])
                  }
                }

                insertPosition++
              }
            }

            const newBytes = await currentPdfDoc.save()
            setPdfBytes(newBytes)
          } else {
            throw new Error("Invalid PDF data")
          }
        } catch (error) {
          console.error("Error inserting PDF page:", error)
        }
      } else if (["excel", "xlsx", "xls", "word", "docx", "doc"].includes(selectedDocument.type)) {
        try {
          for (const pageIndexString of selectedPageIndexes) {
            const pageIndex = Number.parseInt(pageIndexString)
            const content = selectedDocument.processedContent?.[pageIndex]

            if (content) {
              // Create container with custom dimensions
              const fullWidthContent = `
                        <div style="width: ${CUSTOM_PAGE_WIDTH}pt; 
                                    height: ${CUSTOM_PAGE_HEIGHT}pt;
                                    padding: 10pt;
                                    margin: 10px;
                                    padding:10px;
                                    page-break-after: always;">
                            ${content}
                        </div>`
              const pdfArrayBuffer = await convertHtmlToPdf(fullWidthContent, htmlPdfOptions)
              const convertedPdfDoc = await PDFDocument.load(pdfArrayBuffer)
              const [copiedPage] = await currentPdfDoc.copyPages(convertedPdfDoc, [0])

              // Get the original width and height of this copied page
              const { width, height } = copiedPage.getSize()

              // Set the page size dynamically (same as original)
              copiedPage.setSize(width, height)

              // Insert the page into current PDF at the desired position
              currentPdfDoc.insertPage(insertPosition, copiedPage)

              const actualInsertIndex = insertPosition

              setProposalsContents((prevContents) => ({
                ...prevContents,
                [actualInsertIndex]: (prevContents?.[actualInsertIndex] || "") + content,
              }))

              setProposalIsEditable((prev) => {
                const updated = [...prev]
                updated[actualInsertIndex] = { isEditable: true, type: true }
                return updated
              })

              setUpdatedPageContents((prev) => [
                ...prev,
                {
                  document_id: saveId || "",
                  old_index: pageIndex,
                  new_index: actualInsertIndex,
                  content,
                },
              ])

              insertPosition++
            }
          }

          const newBytes = await currentPdfDoc.save()
          setPdfBytes(newBytes)
        } catch (error) {
          console.error(`Error inserting ${selectedDocument.type} page:`, error)
        }
      }
      if (insertPosition > 0) {
        const lastInsertedIndex = insertPosition - 1
        setCurrentPageIndex(lastInsertedIndex)

        const insertedContent = proposalsContents?.[lastInsertedIndex] || ""
        setEditorContent(insertedContent)
        newPageContentRef.current = insertedContent

        if (editorRef.current) {
          editorRef.current.setData(insertedContent)
        }
      }
      // setSelectedProposals({})
    } catch (error) {
      dispatch(callCommonAction({ loading2: false }))
      console.error("Error inserting multiple pages:", error)
    } finally {
      dispatch(callCommonAction({ loading2: false }))
      setIsProcessing(false)
      setIsIframeLoading(false)
      setSelectAll(false)
    }
  }

  // Toggle select all documents
  const toggleSelectAll = () => {
    const newSelectAllState = !selectAll
    setSelectAll(newSelectAllState)

    // If we have a selected document, select or deselect all its pages
    if (selectedDocument) {
      const docIndex = documentList.indexOf(selectedDocument)
      const pages = documentPagesMap[docIndex] || []

      const newSelectedProposals = {}
      pages.forEach((pageIndex) => {
        newSelectedProposals[pageIndex] = newSelectAllState
      })

      setSelectedProposals(newSelectedProposals)

      // Also update preview selections
      const newPreviewSelectedImages = {}
      pages.forEach((pageIndex) => {
        newPreviewSelectedImages[`${docIndex}-${pageIndex}`] = newSelectAllState
      })

      setPreviewSelectedImages(newPreviewSelectedImages)
    }
  }

  // Confirm before deleting a tag
  const confirmBeforeDelete = () => {
    const pageIndicesToRemove = Object.keys(selectedPagesToRemove)
      .filter((key) => selectedPagesToRemove[key])
      .map((key) => Number(key))
      .sort((a, b) => b - a)

    const custom = Alert.confirmDelete(pageIndicesToRemove, removeMultiplePages, () =>
      dispatch(callCommonAction({ alert: null })),
    )
    dispatch(callCommonAction({ alert: custom }))
  }

  const handleDeleteClick = (pageIndex) => {
    const custom = Alert.confirmDelete(
      [pageIndex],
      () => removeMultiplePagesDeleteIcon([pageIndex]),
      () => dispatch(callCommonAction({ alert: null })),
    )
    dispatch(callCommonAction({ alert: custom }))
  }

  const removeMultiplePages = async () => {
    if (!pdfBytes) {
      return
    }

    try {
      setIsProcessing(true)
      setIsIframeLoading(true)
      dispatch(callCommonAction({ loading3: true }))
      const data = newPageContentRef.current
      const pageIndicesToRemove = Object.keys(selectedPagesToRemove)
        .filter((key) => selectedPagesToRemove[key])
        .map((key) => Number(key))
        .sort((a, b) => b - a) // Reverse sort for safe removal

      const pdfDoc = await PDFDocument.load(pdfBytes)
      const pageCountBefore = pdfDoc.getPageCount()

      // Prevent removing all pages
      if (pageIndicesToRemove.length >= pageCountBefore) {
        setIsProcessing(false)
        dispatch(callCommonAction({ loading3: false }))
        setIsIframeLoading(false)
        return
      }

      // Remove selected pages from the PDF
      for (const pageIndex of pageIndicesToRemove) {
        pdfDoc.removePage(pageIndex)
      }

      const newPdfBytes = await pdfDoc.save()
      setPdfBytes(newPdfBytes)

      // Create a mapping of old indices to new indices
      const indexMapping = []
      let newIndex = 0

      for (let oldIndex = 0; oldIndex < pageCountBefore; oldIndex++) {
        if (pageIndicesToRemove.includes(oldIndex)) {
          // Skip removed pages entirely - don't add them to mapping
          continue
        } else {
          // For kept pages, map old index to new index
          indexMapping.push({
            old_index: oldIndex,
            new_index: newIndex,
          })
          newIndex++
        }
      }

      // Update proposalsContents with new indices
      // Create a mapping of old indices to new indices
      const newContents = {}
      for (const mapping of indexMapping) {
        if (proposalsContents[mapping.old_index]) {
          // Ensure we are updating content per page, without affecting others
          newContents[mapping.new_index] = proposalsContents[mapping.old_index]
        }
      }

      setProposalsContents(newContents) // Update with the correctly mapped content

      // Update updatedPageContents for API - ONLY include shifted pages
      const updatedIndexList = []

      // Only add entries for pages that have shifted
      indexMapping.forEach((mapping) => {
        // Only include pages that had their index changed
        if (mapping.old_index !== mapping.new_index) {
          updatedIndexList.push({
            old_index: mapping.old_index,
            new_index: mapping.new_index,
            document_id: saveId || "",
            content: data,
          })
        }
      })

      setUpdatedPageContents(updatedIndexList)
      setSelectedPagesToRemove({})

      // Adjust currentPageIndex
      if (pageIndicesToRemove.includes(currentPageIndex)) {
        setCurrentPageIndex(0) // Reset to first page if current page was removed
      } else {
        let newCurrentIndex = currentPageIndex
        for (const removedIndex of pageIndicesToRemove) {
          if (removedIndex < currentPageIndex) {
            newCurrentIndex-- // Decrement current page index if removed page is before it
          }
        }
        setCurrentPageIndex(Math.max(0, newCurrentIndex))
      }

      dispatch(callCommonAction({ alert: null }))
    } catch (error) {
      console.error("Error removing multiple pages:", error)
    } finally {
      setIsProcessing(false)
      dispatch(callCommonAction({ loading3: false }))
      setIsIframeLoading(false)
    }
  }

  const removeMultiplePagesDeleteIcon = async (overridePagesToRemove = null) => {
    const pagesToRemove =
      overridePagesToRemove ||
      Object.keys(selectedPagesToRemove)
        .filter((key) => selectedPagesToRemove[key])
        .map((key) => Number(key))
        .sort((a, b) => b - a) // Reverse sort

    if (!pdfBytes || pagesToRemove.length === 0) return

    try {
      setIsProcessing(true)
      setIsIframeLoading(true)
      dispatch(callCommonAction({ loading3: true }))

      const pdfDoc = await PDFDocument.load(pdfBytes)
      const pageCountBefore = pdfDoc.getPageCount()

      if (pagesToRemove.length >= pageCountBefore) {
        setIsProcessing(false)
        setIsIframeLoading(false)
        dispatch(callCommonAction({ loading3: false }))
        return
      }

      // Remove pages
      for (const pageIndex of pagesToRemove) {
        pdfDoc.removePage(pageIndex)
      }

      const newPdfBytes = await pdfDoc.save()
      setPdfBytes(newPdfBytes)

      // Update contents mapping as before...
      // (Keep your existing content remapping logic here)

      setSelectedPagesToRemove({})
      if (pagesToRemove.includes(currentPageIndex)) {
        setCurrentPageIndex(0)
      } else {
        let newIndex = currentPageIndex
        for (const removed of pagesToRemove) {
          if (removed < currentPageIndex) newIndex--
        }
        setCurrentPageIndex(Math.max(0, newIndex))
      }

      dispatch(callCommonAction({ alert: null }))
    } catch (err) {
      console.error("Error removing pages:", err)
    } finally {
      setIsProcessing(false)
      setIsIframeLoading(false)
      dispatch(callCommonAction({ loading3: false }))
    }
  }

  const toggleProposalSelection = (pageIndex) => {
    const isAlreadySelected =
      pageSelection?.document_id === selectedDocument?.id && pageSelection?.selected_pages?.includes(Number(pageIndex))

    const applyToggle = () => {
      setSelectedProposals((prev) => {
        const newState = {
          ...prev,
          [pageIndex]: !prev[pageIndex],
        }

        if (isAlreadySelected && !newState[pageIndex]) {
          setPageSelection((prevSelection) => {
            if (!prevSelection || !prevSelection.selected_pages) return prevSelection
            const updatedPages = prevSelection.selected_pages.filter((page) => page !== Number(pageIndex))
            return {
              ...prevSelection,
              selected_pages: updatedPages,
            }
          })
        }

        const allSelected = documentPagesMap[documentList.indexOf(selectedDocument)]?.every(
          (_, index) => newState[index],
        )
        setSelectAll(allSelected)

        if (selectedDocument) {
          const docIndex = documentList.indexOf(selectedDocument)
          setPreviewSelectedImages((prevPreview) => ({
            ...prevPreview,
            [`${docIndex}-${pageIndex}`]: newState[pageIndex],
          }))
        }

        return newState
      })
    }

    // If trying to unselect, simulate "double-click"
    if (isAlreadySelected) {
      applyToggle() // first click
      applyToggle() // second click (simulated)
    } else {
      applyToggle() // normal single click
    }
  }

  // Toggle page selection for removal
  const togglePageToRemove = (pageIndex) => {
    setSelectedPagesToRemove((prev) => ({
      ...prev,
      [pageIndex]: !prev[pageIndex],
    }))
  }

  // Handle delete document
  const handleDeleteDocument = (doc) => {
    // Show confirmation dialog
    const custom = Alert.confirmDelete(
      [doc.name],
      () => deleteDocument(doc.id),
      () => dispatch(callCommonAction({ alert: null })),
    )
    dispatch(callCommonAction({ alert: custom }))
  }

  // Delete document API call
  const deleteDocument = async (docId) => {
    dispatch(callCommonAction({ alert: null }))

    if (docId) {
      try {
        // Set tab loading to true
        setTabLoading((prev) => ({ ...prev, [activeSection]: true }))

        const res = await sendRequest(`/user/document/${docId}`, "DELETE")

        if (res.data.type === "success") {
          handleClick("myDocs")
          await getRawData("myDocs")
          clearThumbnailCache(docId)
        }
      } catch (error) {
        // Optional: handle error UI
      } finally {
        // Always stop loading spinner
        setTabLoading((prev) => ({ ...prev, [activeSection]: false }))
        dispatch(callCommonAction({ loading: false }))
      }
    }
  }

  // Handle edit document
  const handleEditDocument = (doc) => {
    console.log(doc, "docdocdoc")
    setSelectedDocumentId(doc.id) // Set the document to edit
    setShowUserDocumentPopup(true)
  }

  // Handle CKEditor instance ready
  const handleEditorInstanceReady = (editor) => {
    editorRef.current = editor.editor
    // If there's already a selected page, set its content
    if (currentPageIndex !== null) {
      const content = proposalsContents[currentPageIndex] || ""

      editor.editor.setData(content)
      setIsIframeLoading(false)
    }
  }

  // Get file type icon
  const getFileTypeIcon = (fileType) => {
    switch (fileType) {
      case "pdf":
        return <iconify-icon icon="material-icon-theme:pdf" class="fs-3"></iconify-icon>
      case "excel":
      case "xlsx":
      case "xls":
        return <iconify-icon icon="vscode-icons:file-type-excel" class="fs-3"></iconify-icon>
      case "word":
      case "docx":
      case "doc":
        return <iconify-icon icon="vscode-icons:file-type-word" class="fs-3"></iconify-icon>
      default:
        return <iconify-icon icon="material-icon-theme:pdf" class="fs-3"></iconify-icon>
    }
  }

  // Count selected pages
  const selectedPageCount = Object.values(selectedProposals).filter(Boolean).length

  // Count selected pages to remove
  const selectedPagesToRemoveCount = Object.values(selectedPagesToRemove).filter(Boolean).length

  // Count selected preview images
  const selectedPreviewImagesCount = Object.values(previewSelectedImages).filter(Boolean).length

  /** Applied Filter Here */
  const applyFilter = () => {
    getRawData(key, filter.search)
    selectRef.current?.focus()
  }

  /** Reset Filter Here */
  const clearFilter = () => {
    setFilter({ search: "" })
    getRawData(key, "")
    setSelectedDocument(null)
    setViewMode("list") // Reset to list view when clearing filter
  }

  // Calculate column widths based on panel visibility
  const getColumnWidths = () => {
    if (!leftPanelVisible && !rightPanelVisible) {
      return { left: 0, middle: 12, right: 0 }
    } else if (!leftPanelVisible) {
      return { left: 0, middle: 9, right: 3 }
    } else if (!rightPanelVisible) {
      return { left: 3, middle: 9, right: 0 }
    } else {
      return { left: 3, middle: 6, right: 3 }
    }
  }

  const handleClick = (section) => {
    setActiveSection(section) // set active
    setTabLoading((prev) => ({
      ...prev,
      [section]: true,
    }))

    setKey(section)
    setSelectedDocument(null)
    setViewMode("list")
    setActiveSection(section) // Set active section immediately for UI feedback

    dispatch(callCommonAction({ loading5: true }))

    getRawData(section).finally(() => {
      dispatch(callCommonAction({ loading5: false }))
      setTabLoading((prev) => ({
        ...prev,
        [section]: false,
      }))
      setDocumentPagesMap("")
      setIsTabChanging(false)
    })
  }

  const checkForImageData = (content) => {
    if (!content) return false
    return content.includes("<img") || content.includes("inserted-page-content")
  }

  const columnWidths = getColumnWidths()

  // Load cache from localStorage on component mount
  useEffect(() => {
    try {
      const savedCache = localStorage.getItem("thumbnailCache")
      if (savedCache) {
        setThumbnailCache(JSON.parse(savedCache))
        console.log("Loaded thumbnail cache from localStorage")
      }
    } catch (error) {
      console.error("Error loading thumbnail cache from localStorage:", error)
    }
  }, [])

  // Save cache to localStorage when it changes
  useEffect(() => {
    try {
      if (Object.keys(thumbnailCache).length > 0) {
        localStorage.setItem("thumbnailCache", JSON.stringify(thumbnailCache))
        console.log("Saved thumbnail cache to localStorage")
      }
    } catch (error) {
      console.error("Error saving thumbnail cache to localStorage:", error)
    }
  }, [thumbnailCache])

  const sectionLabels = {
    myDocs: "My Docs",
    oldDocs: "Old Docs",
    masterDocs: "Master Docs",
    drafts: "Drafts",
    rejected: "Rejected",
  }

  const getActiveSectionLabel = () => {
    // If activeSection is one of the special keys, use sectionLabels
    if (sectionLabels[activeSection]) {
      return sectionLabels[activeSection]
    }

    // Otherwise, try to find the category name by id
    const category = categories.find((cat) => cat.id === activeSection)
    if (category) {
      return category.name
    }

    // Default fallback
    return "Filter Docs"
  }

  return (
    <>
      <div className="row">
        {/* Left Column: Editor */}
        {alert}
        <div
          className={` ${leftPanelVisible ? "col" : "hidden-panel"} ${rightPanelVisible ? "" : "expanded"} left-panel position-relative`}
        >
          <div className="side-panel ps-3">
            {leftPanelVisible ? (
              <div className="d-flex justify-content-between align-items-center mb-0 pb-2 pt-2 ps-3 pe-2 panel-header">
                <h2 className="d-inline-flex fs-14 fw-light mb-0 flex-column align-items-start">
                  <span
                    className="mb-1 fs-12 d-inline-flex align-items-center gap-1 pointer backbtn"
                    onClick={() => navigate(appRoutes.listProposalRoute)}
                  >
                    <iconify-icon icon="weui:back-filled" class="fs-6 yellow"></iconify-icon> Back
                  </span>
                  {/* <span className="d-inline-flex align-items-center fw-normal">Document Editor</span> */}
                </h2>
                <div className="d-flex align-items-center gap-1">
                  <button
                    onClick={() => confirmBeforeReset("manualValue")}
                    // disabled={id}
                    className="d-flex align-items-center gap-1 btn btn-sm btn-outline-custom p-2 py-1 rounded-2"
                    style={{ minHeight: "auto" }}
                  >
                    <iconify-icon icon="ooui:reload" class="fs-16"></iconify-icon> Reset
                  </button>

                  <button className="btn-cross pe-0" onClick={toggleLeftPanel} title="Hide panel">
                    <iconify-icon icon="basil:cross-solid" class="fs-2" style={{ height: "26px" }}></iconify-icon>
                  </button>
                </div>
              </div>
            ) : (
              <>
                <div className="text-center">
                  <button
                    onClick={toggleLeftPanel}
                    className="btn btn-sm rounded-circle circle-arrow d-inline-flex justify-content-center align-items-center"
                  >
                    <iconify-icon icon="mynaui:arrow-right" class="fs-5 text-white"></iconify-icon>
                  </button>
                  <div className="toggle-text">Open Document Editor</div>
                </div>
              </>
            )}
            <div className="overflow-y-auto fix-height ">
              {leftPanelVisible && (
                <div className="mt-0 pe-3 py-3">
                  <div className="">
                    {/* Page Selector */}
                    {pdfBytes && renderPageSelector()}

                    {/* CKEditor */}
                    <div className="mb-4">
                      <CKEditor
                        key={currentPageIndex}
                        initData={editorContent}
                        data={editorContent}
                        onInstanceReady={handleEditorInstanceReady}
                        onChange={(event) => {
                          const data = event.editor.getData()
                          newPageContentRef.current = data

                          // Clear error if content is not empty or just whitespace
                          if (data && data.trim() !== "" && data.trim() !== "<p>&nbsp;</p>") {
                            setCkeContentError("")
                          }

                          // Check if the content has image data
                          setHasImageData(checkForImageData(data))
                        }}
                        config={{
                          allowedContent: true, // ✅ Allow all HTML, styles, classes, attributes
                          height: 400,
                          allowedContent: true, // ✅ Allow all HTML, styles, classes, attributes
                          extraPlugins: "colorbutton,font,justify,preview,find,flash,forms,iframe,pagebreak",
                          removePlugins: "elementspath",
                          resize_enabled: true,
                          toolbar: [
                            {
                              name: "basicstyles",
                              items: [
                                "Bold",
                                "Italic",
                                "Underline",
                                "NumberedList",
                                "BulletedList",
                                "JustifyLeft",
                                "JustifyCenter",
                                "JustifyRight",
                                "JustifyBlock",
                                "Image",
                                "Table",
                                "TextColor",
                                "BGColor",
                                "Styles",
                                "Format",
                                "Font",
                                "FontSize",
                              ],
                            },
                          ],
                        }}
                      />
                    </div>
                    {ckeContentError && <div className="text-danger mt-2">{ckeContentError}</div>}

                    <div className="mb-4">
                      {currentPageIndex !== null && pdfBytes && (
                        <div className="text-center mb-4">
                          {(() => {
                            const pageInfo = proposalIsEditable // Access pageInfo for the currentPageIndex
                            const editablePageIndexes = proposal?.document_contents?.map((doc) => doc.page_index) || []
                            const isCurrentPageEditable = id
                              ? editablePageIndexes.includes(currentPageIndex) // Use this only if there's an ID
                              : pageInfo?.isEditable && pageInfo?.type !== "pdf" // Fallback if no ID
                            return (
                              <button
                                type="submit"
                                disabled={loading1}
                                // disabled={loading1}
                                className="btn btn-outline-custom btn-sm d-inline-flex px-3 py-2 rounded-3"
                              >
                                {loading1 ? (
                                  <span className="indicator-progress" style={{ display: "block" }}>
                                    Please wait...
                                    <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                  </span>
                                ) : (
                                  <span
                                    className="d-inline-flex align-items-center"
                                    onClick={updateSelectedProposalContentWithHTML}
                                  >
                                    <iconify-icon icon="mdi:file-tick" class="fs-5 me-1 yellow"></iconify-icon>
                                    Update Page with Content
                                  </span>
                                )}
                              </button>
                            )
                          })()}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Current Document Pages with Checkboxes for Removal */}
                  {pdfBytes && Object.keys(proposalImages).length > 1 && (
                    <div className="mt-4">
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <h6 className="mb-0 fs-12">Remove Document:</h6>
                      </div>

                      <div className="row row-cols-1 row-cols-md-2 row-cols-xl-3 remove-document m-0">
                        {Object.keys(proposalImages).map((pageIndex) => (
                          <div key={`current-${pageIndex}`} className="page-thumbnail">
                            <div className="page-thumbnail-inner">
                              {/* Delete Icon for page removal */}
                              <div className="delete-icon position-absolute">
                                <button
                                  className="btn btn-link p-0"
                                  disabled={pageIndex == 0}
                                  onClick={() => handleDeleteClick(Number(pageIndex))}
                                >
                                  <iconify-icon icon="iconamoon:trash" class="fs-6 me-1 yellow"></iconify-icon>
                                </button>
                              </div>

                              {/* Checkbox for page selection */}
                              <div className="form-check position-absolute">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id={`remove-page-${pageIndex}`}
                                  checked={!!selectedPagesToRemove[pageIndex]}
                                  onChange={() => togglePageToRemove(Number(pageIndex))}
                                  disabled={pageIndex == 0} // Disable for pageIndex 0
                                />
                              </div>

                              {/* Thumbnail image */}
                              <img
                                className="page-thumbnail-img img-fluid"
                                src={proposalImages[pageIndex] || "/placeholder.svg?height=100&width=80"}
                                alt={`Page ${Number(pageIndex) + 1}`}
                                onClick={() => {
                                  handleThumbnailPreview(
                                    proposalImages[pageIndex],
                                    pdfBytes,
                                    Number(pageIndex),
                                    null,
                                    true,
                                  )
                                }}
                              />
                              <div className="fs-12 text-center pt-1">Page {Number(pageIndex) + 1}</div>
                            </div>
                          </div>
                        ))}
                      </div>

                      <div className="mb-4 mt-4">
                        <button
                          type="submit"
                          disabled={loading3 || selectedPagesToRemoveCount === 0}
                          className=" btn btn-outline-custom btn-sm d-inline-flex px-3 py-2 rounded-3"
                        >
                          {loading3 ? (
                            <span className="indicator-progress" style={{ display: "block" }}>
                              Please wait...
                              <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                            </span>
                          ) : (
                            <span className="d-inline-flex align-items-center" onClick={confirmBeforeDelete}>
                              <iconify-icon icon="iconamoon:trash" class="fs-4 me-1 yellow"></iconify-icon> Remove
                              Selected Pages ({selectedPagesToRemoveCount})
                            </span>
                          )}
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
            <div
              className={` ${leftPanelVisible ? "col px-1 " : "px-2 "} gap-1 py-2 d-flex flex-wrap justify-content-center panel-footer`}
            >
              <button
                className={` ${leftPanelVisible ? "px-2" : "px-2  "} justify-content-center flex-fill btn btn-outline-custom btn-sm d-inline-flex  py-2 rounded-3`}
                onClick={() => {
                  setDocumentProposalData((prev) => ({ ...prev, is_draft: false }))

                  handleDownloadClick()
                }}
                disabled={!pdfBytes}
              >
                <span class="d-inline-flex align-items-center">
                  <iconify-icon
                    icon="tdesign:save"
                    class={` ${leftPanelVisible ? "fs-5" : "fs-6"} yellow me-1`}
                  ></iconify-icon>{" "}
                  Send for Approval
                </span>
              </button>
              <button
                className={` ${leftPanelVisible ? "px-1" : "px-2  "} justify-content-center flex-fill btn btn-outline-custom btn-sm d-inline-flex py-2 rounded-3`}
                onClick={() => {
                  setDocumentProposalData((prev) => ({ ...prev, is_draft: true }))
                  handleDownloadClick()
                }}
                disabled={!pdfBytes}
              >
                <span class="d-inline-flex align-items-center">
                  <iconify-icon
                    icon="carbon:rule-draft"
                    class={` ${leftPanelVisible ? "fs-5" : "fs-6"} yellow me-1`}
                  ></iconify-icon>{" "}
                  Save As Draft
                </span>
              </button>

              <button
                className={` ${leftPanelVisible ? "px-1" : "px-2  "} justify-content-center flex-fill btn btn-outline-custom btn-sm d-inline-flex py-2 rounded-3`}
                disabled={!pdfBytes || proposal.status != 1}
              >
                <span className="d-inline-flex align-items-center" onClick={handleButtonClick}>
                  <iconify-icon
                    icon="fluent:mail-24-regular"
                    class={` ${leftPanelVisible ? "fs-5" : "fs-6"} yellow me-1`}
                  ></iconify-icon>{" "}
                  Send to Email
                </span>
              </button>
            </div>
          </div>
        </div>

        {/* Middle Column: PDF Viewer */}
        <div
          className={`col editor-column position-relative ${
            (!leftPanelVisible && !rightPanelVisible) || (editorPanelVisible || rightPanelVisible)
              ? "editorfullwidth"
              : ""
          }`}
          style={{
            width:
              !leftPanelVisible && !rightPanelVisible
                ? "100%"
                : !editorPanelVisible && !rightPanelVisible
                  ? "100px"
                  : "auto",
            maxWidth:
              !leftPanelVisible && !rightPanelVisible
                ? "100%"
                : !editorPanelVisible && !rightPanelVisible
                  ? "100px"
                  : "none",
            transition: "all 0.3s ease",
          }}
        >
          {(!leftPanelVisible && !rightPanelVisible) || editorPanelVisible || rightPanelVisible ? (
            <>
              {leftPanelVisible === true && rightPanelVisible === false && (
                <span className="editor-toggle" onClick={toggleEditor} style={{ cursor: "pointer" }}>
                  <iconify-icon icon="icon-park-solid:left-c" class="fs-20 pointer yellow"></iconify-icon>
                </span>
              )}
              <div className="fix-height position-relative">
                {isIframeLoading && (
                  <div className="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-light bg-opacity-75">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                )}

                {pdfBlobUrl && (
                  <iframe
                    src={pdfBlobUrl}
                    title="PDF Preview"
                    width="100%"
                    height="100%"
                    className="border rounded viewer-iframe"
                    style={{ visibility: isIframeLoading ? "hidden" : "visible" }}
                    key={currentPageIndex} // Add key to force iframe refresh when page changes
                    onLoad={() => setIsIframeLoading(false)}
                  />
                )}
              </div>
            </>
          ) : (
            <>
              <div className="side-panel h-100 pb-0 px-0">
                <div className="text-center">
                  <button
                    onClick={toggleEditor}
                    className="btn btn-sm rounded-circle circle-arrow d-inline-flex justify-content-center align-items-center"
                  >
                    <iconify-icon icon="mynaui:arrow-left" class="fs-5 text-white"></iconify-icon>
                  </button>
                  <div className="toggle-text">Open Editor</div>
                </div>
              </div>
            </>
          )}
        </div>

        {/* Right Column: Document Management */}
        <div className={` ${rightPanelVisible ? "col" : "hidden-panel"} right-panel position-relative`}>
          <div className="side-panel h-100">
            {rightPanelVisible ? (
              <div className="d-flex justify-content-between align-items-center mb-0 pb-2 pt-2 ps-2 pe-3 panel-header z-1">
                <button className="btn-cross ps-0 pe-1" onClick={toggleRightPanel} title="Hide panel">
                  <iconify-icon icon="basil:cross-solid" class="fs-2 mt-1"></iconify-icon>
                </button>
                <div class="w-100 position-relative">
                  <input
                    className="form-control pe-5 bg-light"
                    type="text"
                    value={filter.search}
                    onChange={(e) => setFilter({ ...filter, search: e.target.value })}
                    placeholder="Search Document"
                    aria-label="Search"
                  />
                  <iconify-icon
                    icon="uil:search"
                    onClick={applyFilter}
                    class="end-0 fs-6 position-absolute top-50 translate-middle"
                  ></iconify-icon>
                </div>
                <iconify-icon icon="ooui:reload" onClick={clearFilter} class="fs-6 ms-2 reset-btn"></iconify-icon>
              </div>
            ) : (
              <>
                <div className="text-center">
                  <button
                    onClick={toggleRightPanel}
                    className="btn btn-sm rounded-circle circle-arrow d-inline-flex justify-content-center align-items-center"
                  >
                    <iconify-icon icon="tabler:menu-3" class="fs-5 text-white"></iconify-icon>
                  </button>
                  <div className="toggle-text">Manage Document</div>
                </div>
              </>
            )}
            <div className="overflow-y-auto fix-height">
              {rightPanelVisible && (
                <>
                  <div className="border-bottom d-flex gap-2 justify-content-between mb-3 px-3 py-2">
                    <button className="justify-content-center  btn btn-outline-custom btn-sm d-inline-flex rounded-3 add-doc-btn">
                      <span className="d-inline-flex align-items-center" onClick={handleUserAddDoc}>
                        <iconify-icon
                          icon="ic:baseline-plus"
                          class={` ${leftPanelVisible ? "fs-5" : "fs-6"} yellow me-1`}
                        ></iconify-icon>{" "}
                        Add Doc
                      </span>
                    </button>
                    <div className="dropdown">
                      <a
                        className="no-caret d-inline-flex btn btn-sm btn-outline-custom align-items-center filter-btn"
                        href="#"
                        role="button"
                        id="myActions"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <iconify-icon icon="tabler:menu-3" class="fs-5 yellow me-1"></iconify-icon>{" "}
                        {getActiveSectionLabel()}
                      </a>
                      <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="myActions">
                        {/* Always show "My Docs" */}
                        <li>
                          <a
                            className={`dropdown-item ${activeSection === "myDocs" ? "active" : ""}`}
                            onClick={() => handleClick("myDocs")}
                          >
                            <span className="d-flex align-items-center gap-1">
                              <iconify-icon icon="lets-icons:file" class="fs-6 yellow"></iconify-icon> My Docs
                            </span>
                          </a>
                        </li>

                        <li>
                          <a
                            className={`dropdown-item ${activeSection === "drafts" ? "active" : ""}`}
                            onClick={() => handleClick("drafts")}
                          >
                            <span className="d-flex align-items-center gap-1">
                              <iconify-icon icon="lets-icons:file" class="fs-6 yellow"></iconify-icon> Draft
                            </span>
                          </a>
                        </li>
                        <li>
                          <a
                            className={`dropdown-item ${activeSection === "oldDocs" ? "active" : ""}`}
                            onClick={() => handleClick("oldDocs")}
                          >
                            <span className="d-flex align-items-center gap-1">
                              <iconify-icon icon="lets-icons:file" class="fs-6 yellow"></iconify-icon> Old Docs
                            </span>
                          </a>
                        </li>

                        {/* Then list all categories dynamically */}
                        {categories
                          .filter((category) => category.name !== "Proposal Doc")
                          .map((category) => (
                            <li key={category.id}>
                              <a
                                className={`dropdown-item ${activeSection === category.id ? "active" : ""}`}
                                onClick={() => handleClick(category.id)}
                              >
                                <span className="d-flex align-items-center gap-1">
                                  <iconify-icon icon="lets-icons:file" class="fs-6 yellow"></iconify-icon>
                                  {category.name}
                                </span>
                              </a>
                            </li>
                          ))}
                      </ul>
                    </div>
                  </div>

                  <div className="px-3 pt-0 pb-4">
                    {/* Show loading spinner while data is being fetched */}
                    {tabLoading[activeSection] ? (
                      <div className="text-center p-5">
                        <div>
                          <Spinner animation="border" role="status" variant="warning"></Spinner>
                        </div>
                        <p className="mt-2">Loading documents...</p>
                      </div>
                    ) : (
                      <>
                        {/* Common Document Viewer Component */}
                        {activeSection === "rejected" ? (
                          <div className="comments-section">
                            <Chat rejectedData={rejectedData} setRejectedData={setRejectedData} tabKey="rejected" />
                          </div>
                        ) : (
                          <div className="document-viewer-section">
                            <div className="">
                              {viewMode === "list" ? (
                                <>
                                  <h2 className="fs-14 mt-0 mb-3">
                                    {/* {activeSection === "myDocs" && "My Documents:"} */}
                                    {activeSection === "oldDocs" && "Available Old Documents:"}
                                    {activeSection === "masterDocs" && "Available Master Documents:"}
                                    {activeSection === "drafts" && "Available Drafts:"}
                                  </h2>
                                  {documentList.length === 0 ? (
                                    <p className="py-5 text-center text-muted">No documents available.</p>
                                  ) : (
                                    <div>
                                      {/* Document Selector as UL > LI */}
                                      <div className="mb-3">
                                        <ul className="list-group doc-list">
                                          {documentList.map((doc, index) => (
                                            <li
                                              key={index}
                                              className="list-group-item list-group-item-action border-0 p-1 mb-1"
                                            >
                                              <div className="d-flex align-items-center gap-2 justify-content-between">
                                                <div
                                                  className="d-flex align-items-center flex-fill gap-2 overflow-hidden pointer me-2"
                                                  onClick={() => handleDocumentSelect({ target: { value: index } })}
                                                >
                                                  <span className="symbol-60 d-inline-flex align-items-center justify-content-center">
                                                    {getFileTypeIcon(doc.type)}
                                                  </span>
                                                  <h2 className="fs-12 fw-normal text-body m-0 text-truncate">
                                                    {doc.name}
                                                  </h2>
                                                </div>
                                                <div className="d-flex align-items-center gap-2">
                                                  {activeSection === "myDocs" && (
                                                    <>
                                                      <div className="dropdown">
                                                        <a
                                                          className="align-items-center bg-transparent border-0 btn btn-sm d-inline-flex no-caret px-0"
                                                          href="#"
                                                          role="button"
                                                          id="docActions"
                                                          data-bs-toggle="dropdown"
                                                          aria-expanded="false"
                                                        >
                                                          <iconify-icon
                                                            icon="tabler:dots-vertical"
                                                            class="fs-5 yellow me-1"
                                                          ></iconify-icon>
                                                        </a>
                                                        <ul
                                                          className="dropdown-menu dropdown-menu-end"
                                                          aria-labelledby="docActions"
                                                        >
                                                          {/* <li>
                                                            <a
                                                              href="#"
                                                              className="dropdown-item"
                                                              onClick={() =>
                                                                handleDocumentSelect({ target: { value: index } })
                                                              }
                                                            >
                                                              <span className="d-flex align-items-center gap-2">
                                                                <iconify-icon
                                                                  icon="lucide:eye"
                                                                  class="fs-6 yellow"
                                                                ></iconify-icon>{" "}
                                                                View
                                                              </span>
                                                            </a>
                                                          </li> */}
                                                          <li>
                                                            <a
                                                              href="#"
                                                              className="dropdown-item"
                                                              onClick={(e) => {
                                                                e.stopPropagation()
                                                                handleEditDocument(doc)
                                                              }}
                                                            >
                                                              <span className="d-flex align-items-center gap-2">
                                                                <iconify-icon
                                                                  icon="lucide:edit"
                                                                  class="fs-6 yellow"
                                                                ></iconify-icon>{" "}
                                                                Edit
                                                              </span>
                                                            </a>
                                                          </li>
                                                          <li>
                                                            <a
                                                              href="#"
                                                              className="dropdown-item"
                                                              onClick={(e) => {
                                                                e.stopPropagation()
                                                                handleDeleteDocument(doc)
                                                              }}
                                                            >
                                                              <span className="d-flex align-items-center gap-1">
                                                                <iconify-icon
                                                                  icon="lucide:trash-2"
                                                                  class="fs-6 yellow"
                                                                ></iconify-icon>{" "}
                                                                Delete
                                                              </span>
                                                            </a>
                                                          </li>
                                                        </ul>
                                                      </div>
                                                    </>
                                                  )}
                                                  {activeSection !== "myDocs" && (
                                                    <iconify-icon
                                                      onClick={() => handleDocumentSelect({ target: { value: index } })}
                                                      icon="icon-park-solid:right-c"
                                                      class="fs-20 pointer"
                                                    ></iconify-icon>
                                                  )}
                                                </div>
                                              </div>
                                            </li>
                                          ))}
                                        </ul>
                                      </div>
                                    </div>
                                  )}
                                </>
                              ) : (
                                <>
                                  <div className="d-flex justify-content-between align-items-center mb-3">
                                    <p className="fs-14 mb-0 mt-0 overflow-hidden pe-1 text-truncate">
                                      <button className="btn btn-sm p-0" onClick={backToDocumentList}>
                                        <iconify-icon
                                          icon="weui:back-filled"
                                          class="fs-6 yellow me-1 mt-1"
                                        ></iconify-icon>
                                      </button>

                                      {/*  <OverlayTrigger
                                        placement="top"
                                        overlay={<Tooltip id="tooltip-back">{activeDocumentName}</Tooltip>}
                                      >
                                        <span>{activeDocumentName}</span>
                                      </OverlayTrigger> */}
                                      <a
                                         onClick={(e) => {
    e.preventDefault(); // prevent default link behavior
    // your logic here, e.g., open modal
    console.log("Clicked:", activeDocumentName);
  }}
                                        title={activeDocumentName}
                                        style={{ cursor: "pointer", textDecoration: "none", color: "#333" }}
                                      >
                                        {activeDocumentName}
                                      </a>
                                    </p>

                                    {/* Add Select All checkbox */}
                                    {selectedDocument &&
                                      documentPagesMap[documentList.indexOf(selectedDocument)] &&
                                      documentPagesMap[documentList.indexOf(selectedDocument)].length > 0 && (
                                        <div className="form-check flex-shrink-0">
                                          <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id="select-all-pages"
                                            checked={selectAll}
                                            onChange={toggleSelectAll}
                                          />
                                          <label className="form-check-label fs-12" htmlFor="select-all-pages">
                                            Select All
                                          </label>
                                        </div>
                                      )}
                                  </div>

                                  {thumbnailsLoading || !documentPagesMap[documentList.indexOf(selectedDocument)] ? (
                                    // Check if the selected document is not a "draft" or "oldDocs"
                                    !(activeSection == "drafts") ? (
                                      <div className="text-center p-5">
                                        <div className="spinner-border text-primary" role="status">
                                          <span className="visually-hidden">Loading thumbnails...</span>
                                        </div>
                                        <p className="mt-2">Generating document thumbnails...</p>
                                      </div>
                                    ) : (
                                      <div className="text-center p-5">
                                        <p className="mt-2">Page Reloading...</p>
                                      </div>
                                    )
                                  ) : (
                                    selectedDocument &&
                                    Object.keys(selectedDocument).length > 0 && (
                                      <div className="mb-3 ">
                                        <div className="row row-cols-1 row-cols-md-2 row-cols-xl-3 remove-document m-0">
                                          {documentPagesMap[documentList.indexOf(selectedDocument)] &&
                                            documentPagesMap[documentList.indexOf(selectedDocument)].map(
                                              (pageIndex) => (
                                                <div key={`selected-${pageIndex}`} className="page-thumbnail">
                                                  <div className="page-thumbnail-inner">
                                                    {/* Checkbox for page selection */}
                                                    <div className="form-check position-absolute">
                                                      <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id={`page-${pageIndex}`}
                                                        checked={
                                                          !!selectedProposals[pageIndex] ||
                                                          (pageSelection?.document_id === selectedDocument?.id &&
                                                            pageSelection?.selected_pages?.includes(Number(pageIndex)))
                                                        }
                                                        onChange={() => toggleProposalSelection(pageIndex)}
                                                      />
                                                    </div>

                                                    {/* Thumbnail image */}
                                                    <img
                                                      className="page-thumbnail-img img-fluid"
                                                      src={
                                                        documentproposalImagesMap[
                                                          documentList.indexOf(selectedDocument)
                                                        ]?.[pageIndex] ||
                                                        "/placeholder.svg" ||
                                                        "/placeholder.svg" ||
                                                        "/placeholder.svg" ||
                                                        "/placeholder.svg" ||
                                                        "/placeholder.svg" ||
                                                        "/placeholder.svg" ||
                                                        "/placeholder.svg" ||
                                                        "/placeholder.svg" ||
                                                        "/placeholder.svg" ||
                                                        "/placeholder.svg" ||
                                                        "/placeholder.svg"
                                                      }
                                                      alt={`${selectedDocument.name} - Page ${pageIndex + 1}`}
                                                      style={{ height: "auto", cursor: "pointer" }}
                                                      onClick={() => {
                                                        const imageUrl =
                                                          documentproposalImagesMap[
                                                            documentList.indexOf(selectedDocument)
                                                          ]?.[pageIndex]
                                                        if (imageUrl) {
                                                          handleThumbnailPreview(
                                                            imageUrl,
                                                            selectedDocument.bytes,
                                                            pageIndex,
                                                            documentList.indexOf(selectedDocument),
                                                            false,
                                                          )
                                                        } else {
                                                          toggleProposalSelection(pageIndex)
                                                        }
                                                      }}
                                                    />
                                                    <div className="fs-12 text-center pt-1">
                                                      Page {pageIndex + 1}
                                                      {selectedDocument.type !== "pdf"}
                                                    </div>
                                                  </div>
                                                </div>
                                              ),
                                            )}
                                        </div>
                                      </div>
                                    )
                                  )}
                                </>
                              )}
                            </div>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </>
              )}
            </div>
            {pdfBytes && selectedDocument && rightPanelVisible && (
              <div class=" col px-2 gap-1 py-2 d-flex flex-wrap justify-content-center  panel-footer">
                <>
                  <button
                    type="submit"
                    disabled={loading2 || selectedPageCount === 0}
                    className="btn btn-outline-custom btn-sm d-inline-flex px-3 py-2 rounded-3"
                    onClick={insertMultipleProposalsFromSelectedDocument}
                  >
                    {loading2 ? (
                      <span className="indicator-progress" style={{ display: "block" }}>
                        Please wait...
                        <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                      </span>
                    ) : (
                      <span className="d-inline-flex align-items-center">
                        <iconify-icon icon="carbon:insert" class="fs-5 me-1 yellow"></iconify-icon>
                        Insert as New Pages
                      </span>
                    )}
                  </button>

                  <button
                    type="submit"
                    disabled={
                      loading9 ||
                      selectedPageCount === 0 ||
                      currentPageIndex === null ||
                      hasImageData ||
                      selectedPageCount > 1
                    }
                    className="btn btn-outline-custom btn-sm d-inline-flex px-3 py-2 rounded-3"
                    onClick={insertSelectedPagesOnSamePage}
                  >
                    {loading9 ? (
                      <span className="indicator-progress" style={{ display: "block" }}>
                        Please wait...
                        <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                      </span>
                    ) : (
                      <span className="d-inline-flex align-items-center">
                        <iconify-icon icon="mdi:page-layout-body" class="fs-5 me-1 yellow"></iconify-icon>
                        {hasImageData ? "Remove Inserted Data First" : "Insert on Same Page"}
                      </span>
                    )}
                  </button>
                </>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Preview Popup */}
      {showPreviewPopup && previewImage && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
          style={{ backgroundColor: "rgba(0,0,0,0.7)", zIndex: 1050 }}
        >
          <div
            className="position-relative bg-white p-4 rounded"
            style={{ maxWidth: "90%", maxHeight: "90vh", overflow: "auto" }}
          >
            <button
              className="btn btn-close btn-sm end-0 me-2 mt-2 position-absolute top-0 fs-12"
              onClick={closePreviewPopup}
              aria-label="Close preview"
            ></button>

            <div className="d-flex flex-column">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="mb-0">Image Preview</h5>

                {/* Add file upload button */}
              </div>

              <div className="text-center position-relative">
                <div className="doc-check end-0 form-check position-absolute">
                  {!shouldHidePreview && (
                    <input
                      className="form-check-input m-0"
                      type="checkbox"
                      id="previewImageCheckbox"
                      // checked={!!selectedProposals[currentPreviewPageIdx]} // <-- sync with main
                      checked={
                        !!selectedProposals[currentPreviewPageIdx] ||
                        (pageSelection?.document_id === selectedDocument?.id &&
                          pageSelection?.selected_pages?.includes(Number(currentPreviewPageIdx)))
                      }
                      onChange={() => toggleProposalSelection(currentPreviewPageIdx)} // <-- single source of action
                    />
                  )}
                </div>
                {/* Navigation buttons */}
                {previewableImages.length > 1 && (
                  <>
                    <button
                      className="btn btn-sm btn-light position-absolute top-50 start-0 translate-middle-y"
                      onClick={navigateToPrevPreviewImage}
                      style={{ zIndex: 10 }}
                    >
                      <i className="fa-solid fa-chevron-left"></i>
                    </button>
                    <button
                      className="btn btn-sm btn-light position-absolute top-50 end-0 translate-middle-y"
                      onClick={navigateToNextPreviewImage}
                      style={{ zIndex: 10 }}
                    >
                      <i className="fa-solid fa-chevron-right"></i>
                    </button>
                  </>
                )}

                <img
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    maxHeight: "70vh",
                  }}
                  src={previewImage || "/placeholder.svg"}
                  alt="Page Preview"
                  className="img-fluid"
                />

                <div className="mt-2 text-muted small">
                  {currentPreviewImageIndex + 1} of {previewableImages.length}
                </div>
              </div>

              {/* Show thumbnails of all pages with checkboxes for multi-selection */}
              {!shouldHidePreview && (
                <div className="mt-4">
                  <div className="d-flex flex-wrap gap-2 mt-2" style={{ maxHeight: "150px", overflowY: "auto" }}>
                    {previewableImages.map((img, index) => (
                      <div
                        key={`preview-thumb-${index}`}
                        className="position-relative"
                        style={{
                          border:
                            currentPreviewImageIndex === index
                              ? "2px solid #ffc107" // yellow border when selected
                              : "1px solid #dee2e6",
                          borderRadius: "4px",
                          padding: "3px",
                          transition: "border 0.2s",
                          cursor: "pointer",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.border = "2px solid #ffc107"
                        }}
                        onMouseLeave={(e) => {
                          if (currentPreviewImageIndex !== index) {
                            e.currentTarget.style.border = "1px solid #dee2e6"
                          }
                        }}
                      >
                        {!shouldHidePreview && (
                          <div
                            className="form-check position-absolute "
                            style={{ top: "5px", right: "5px", zIndex: 10 }}
                          >
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={
                                selectAll ||
                                !!previewSelectedImages[`${img.docIndex}-${img.pageIdx}`] ||
                                !!selectedProposals[img.pageIdx] ||
                                (pageSelection?.document_id === selectedDocument?.id &&
                                  pageSelection?.selected_pages?.includes(Number(img.pageIdx)))
                              }
                              onChange={() => {
                                // Update preview selection
                                setPreviewSelectedImages((prev) => ({
                                  ...prev,
                                  [`${img.docIndex}-${img.pageIdx}`]: !prev[`${img.docIndex}-${img.pageIdx}`],
                                }))

                                // Also update main view selection if this is from the document list
                                if (img.docIndex !== null && img.pageIdx !== null) {
                                  toggleProposalSelection(img.pageIdx)
                                }
                              }}
                            />
                          </div>
                        )}
                        <img
                          src={img.imageUrl || "/placeholder.svg"}
                          alt={`Thumbnail ${index + 1}`}
                          style={{ width: "60px", height: "auto", cursor: "pointer" }}
                          onClick={() => {
                            setCurrentPreviewImageIndex(index)
                            setPreviewImage(img.imageUrl)
                            setCurrentPreviewDocBytes(img.docBytes)
                            setCurrentPreviewPageIdx(img.pageIdx)
                            setCurrentPreviewDocIndex(img.docIndex)

                            // Generate high-res version if needed
                            const cacheKey = `${img.docBytes}-${img.pageIdx}`
                            if (highResPreviewCache[cacheKey]) {
                              setPreviewImage(highResPreviewCache[cacheKey])
                            } else {
                              renderProposalAsImage(img.docBytes, img.pageIdx, 2.0).then((highResImage) => {
                                if (highResImage) {
                                  setPreviewImage(highResImage)
                                  setHighResPreviewCache((prev) => ({
                                    ...prev,
                                    [cacheKey]: highResImage,
                                  }))
                                }
                              })
                            }
                          }}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {!shouldHidePreview && (
                <div className="d-flex justify-content-between mt-3 align-items-center gap-3">
                  <span className="text-muted fs-12">
                    {selectedPreviewImagesCount > 0
                      ? `${selectedPreviewImagesCount} page(s) selected`
                      : "No pages selected"}
                  </span>
                  <div className="d-flex gap-2">
                    <button
                      className="btn btn-outline-custom btn-sm d-inline-flex px-3 py-2 rounded-3"
                      onClick={() => {
                        // First close the popup
                        setShowPreviewPopup(false)

                        // Then call the insertSelectedPagesOnSamePage function with the selected pages
                        if (currentPageIndex !== null && selectedPreviewImagesCount > 0) {
                          // Transfer selections from preview to main view if needed
                          if (selectedDocument) {
                            const docIndex = documentList.indexOf(selectedDocument)
                            Object.keys(previewSelectedImages).forEach((key) => {
                              if (previewSelectedImages[key]) {
                                const [previewDocIndex, pageIdx] = key.split("-")
                                if (previewDocIndex == docIndex) {
                                  // Toggle between 0, -1, and 1
                                  setSelectedProposals((prev) => {
                                    const updatedState = { ...prev }
                                    updatedState[pageIdx] =
                                      updatedState[pageIdx] === 1 ? 0 : updatedState[pageIdx] === 0 ? -1 : 1
                                    return updatedState
                                  })
                                }
                              }
                            })
                          }

                          // Call the function with a slight delay to ensure state updates
                          setTimeout(() => {
                            insertSelectedPagesOnSamePage()
                          }, 100)
                        }
                      }}
                      disabled={
                        selectedPreviewImagesCount === 0 ||
                        currentPageIndex === null ||
                        hasImageData ||
                        selectedPreviewImagesCount > 1
                      }
                    >
                      <span className="d-inline-flex align-items-center">
                        <iconify-icon icon="mdi:page-layout-body" class="fs-5 me-1 yellow"></iconify-icon>
                        {hasImageData ? "Remove Image Data First" : "Insert on Same Page"}
                      </span>
                    </button>

                    <button
                      className="btn btn-outline-custom active btn-sm d-inline-flex px-3 py-2 rounded-3"
                      onClick={() => insertSelectedPreviewImages()}
                      disabled={selectedPreviewImagesCount === 0 && currentPreviewPageIdx === null}
                    >
                      <span className="d-inline-flex align-items-center">
                        <iconify-icon icon="carbon:insert" class="fs-5 me-1"></iconify-icon>
                        Insert as New Pages
                      </span>
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      <Modal show={showDownloadPopup} onHide={() => setShowDownloadPopup(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title className="fs-6">Save Document</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Document Title*</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter document title"
                value={documentProposalData.title}
                onChange={(e) =>
                  setDocumentProposalData((prevData) => ({
                    ...prevData,
                    title: e.target.value,
                  }))
                }
                onBlur={() => checkFormIsValid("title")}
                isInvalid={!!errorsInfo.title}
              />
              {errorsInfo.title && <Form.Text className="text-danger">{errorsInfo.title}</Form.Text>}
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Meta Title</Form.Label>
              <div className="position-relative">
                <div
                  className="d-flex flex-wrap align-items-center p-2 border rounded mb-1"
                  style={{
                    minHeight: "50px",
                    gap: "5px",
                    cursor: "text",
                  }}
                  onClick={() => document.getElementById("tagInput").focus()}
                >
                  {tags.map((tag, index) => (
                    <div
                      key={index}
                      className="badge d-flex align-items-center"
                      style={{
                        backgroundColor: "rgb(230, 230, 230)",
                        color: "#606060 ",
                        padding: "6px",
                        borderRadius: "4px",
                        fontSize: "11px",
                        fontWeight: 500,
                      }}
                    >
                      {tag}
                      <button
                        type="button"
                        className="btn-close btn-close-sm ms-2"
                        style={{ fontSize: "10px", padding: "0" }}
                        onClick={(e) => removeTag(tag, e)}
                        aria-label="Remove tag"
                      />
                    </div>
                  ))}

                  <input
                    id="tagInput"
                    type="text"
                    placeholder={tags.length > 0 ? "Add more..." : "Enter meta title and press Enter"}
                    value={rawInput} // Use rawInput instead of documentProposalData.metatitle
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                    onBlur={() => checkFormIsValid("metatitle")}
                    style={{
                      flex: 1,
                      border: "none",
                      outline: "none",
                      minWidth: "120px",
                    }}
                  />
                </div>
              </div>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <button onClick={() => setShowDownloadPopup(false)} class="btn btn-outline-custom btn-sm px-3 py-2 rounded-3">
            Close
          </button>

          {loading7 ? (
            <>
              Please wait...
              <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
            </>
          ) : (
            <button
              type="submit"
              onClick={handleDownloadConfirm}
              disabled={loading7}
              className=" btn btn-outline-custom active btn-sm d-inline-flex px-3 py-2 rounded-3"
            >
              {loading7 ? (
                <span className="indicator-progress " style={{ display: "block" }}>
                  Please wait...
                  <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                </span>
              ) : (
                <span className="text-uppercase d-flex align-items-center">
                  {" "}
                  <iconify-icon icon="material-symbols:download" class="fs-5 me-1"></iconify-icon>Save & Download
                </span>
              )}
            </button>
          )}
        </Modal.Footer>
      </Modal>
      {showModal && (
        <SendPdfToEmail
          showPopup={showModal}
          setShowModal={setShowModal}
          file={pdfBytes}
          proposalsContents={proposalsContents}
          users={users}
        />
      )}

      {showUserAddDocument && (
        <UserAddDocument
          showUserDocumentPopup={showUserAddDocument}
          setShowUserDocumentPopup={setShowUserDocumentPopup}
          handleClick={handleClick} // <-- pass this
          docId={selectedDocumentId}
        />
      )}
    </>
  )
}

export default PdfEditor
